/*
 * infini.jsb
 * Copyright(c) 2009, Ipek Guven
 */

Ext.ns('Infini');

// Global Ext settings
Ext.MessageBox.minWidth = 400;
Ext.MessageBox.minPromptWidth = 350;

// Global Infini settings and definitions
Infini.Global = function() {

  return {
    init: function() {
      String.prototype.getEnglishCharSubstitute = function() {
        var string = this;
        var letters = { "ç": "c", "ğ": "g", "ı": "i", "ö": "o", "ş": "s", "ü": "u" };
        string = string.replace(/(([çğıöşü]))/g, function(letter) { return letters[letter]; });
        letters = { "Ç": "C", "Ğ": "G", "İ": "I", "Ö": "O", "Ş": "S", "Ü": "U" };
        string = string.replace(/(([ÇĞİÖŞÜ]))/g, function(letter) { return letters[letter]; });
        return string;
      };

      String.prototype.toLocaleLowerCaseEx = function(locale = 'tr-TR') {
        let str = this;
        if (locale !== 'tr-TR')
          str = str.getEnglishCharSubstitute();

        return str.toLocaleLowerCase(locale);
      };

      String.prototype.toLocaleUpperCaseEx = function(locale = 'tr-TR') {
        let str = this;
        if (locale !== 'tr-TR')
          str = str.getEnglishCharSubstitute();

        return str.toLocaleUpperCase(locale);
      };

      String.prototype.toLocaleTitleCase = function(locale = 'tr-TR') {
        let str = this.toLocaleLowerCase(locale).split(' ');
        for (var i = 0; i < str.length; i++) {
          str[i] = str[i].charAt(0).toLocaleUpperCase(locale) + str[i].slice(1);
        }
        return str.join(' ');
      };

      String.prototype.toLocaleCamelCase = function(locale = 'tr-TR') {
        let STR = this.toLocaleLowerCase(locale)
          .trim()
          .split(/[ -_]/g)
          .map(word => word.replace(word[0], word[0].toString().toLocaleUpperCase(locale)))
          .join('');
        return STR.replace(STR[0], STR[0].toLocaleLowerCase(locale));
      };
    }
  };
}();

Ext.ns('Infini.SampleData');

Infini.SampleData.KamPublication_01 = {
  data: [
    //{Id: 1, Date: '2008-03-07T00:00:00', Publisher: 'Akçiğer Arşivi', 
    //  Subject: 'AMİNOFİLİNLE BİRLİKTE KULLANILAN KLARİTROMİSİNİN SERUM TEOFİLİN DÜZEYİNE OLAN ETKİSİ'},
    //{Id: 2, Date: '2006-04-12T00:00:00', Publisher: 'Ege Tıp Dergisi', 
    //  Subject: 'PROINFLAMATUAR SİTOKİNLER : PLEVRAL EFFÜZYONLARIN AYRIMLANMASINDA YARARLIMIDIR?'},
    //{Id: 3, Date: '2009-05-01T00:00:00', Publisher: 'İnfeksiyon  Dergisi', 
    //  Subject: 'TÜBERKÜLOZ ETİYOLOJİSİNDE BAZI SOSYO-DEMOGRAFİK DEĞİŞKENLER'},
    //{Id: 4, Date: '2003-02-28T00:00:00', Publisher: 'Tüberküloz ve Toraks', 
    //  Subject: 'İSTANBUL DİSPANSERLERİ ÇALIŞMALARININ YENİ AKCİĞER TÜBERKÜLOZLU OLGULARIN TANI-TEDAVİ VE TAKİP İŞLEMLERİ AÇISINDAN DEĞERLENDİRİLMESİ'}
  ]
};

Infini.SampleData.KamPublication_02 = {
  data: [
    //{Id: 1, Date: '2003-08-06T00:00:00', Publisher: 'Gülhane Tıp Dergisi', 
    //  Subject: 'AKCİĞER TÜBERKÜLOZLU HASTALARIN ASKER HASTANELERDE İZLENMESİNDEKİ SORUNLAR'},
    //{Id: 2, Date: '2000-02-19T00:00:00', Publisher: 'Ulusal Travma Dergisi', 
    //  Subject: 'UZUN SÜRELİ TATİLLERDE ACİL SERVİS HİZMETLERİ'},
    //{Id: 3, Date: '2000-11-22T00:00:00', Publisher: 'Adli Tıp Bülteni', 
    //  Subject: 'OTOPSİ UYGULAMASINA TOPLUMSAL YAKLAŞIM'},
    //{Id: 4, Date: '2001-09-17T00:00:00', Publisher: 'Akciğer Arşivi', 
    //  Subject: 'İZMİR İLİ VEREM SAVAŞI DİSPANSERLERİNDE LATENT TÜBERKÜLOZ ENFEKSİYONU TEDAVİSİ'},
    //{Id: 5, Date: '2004-12-11T00:00:00', Publisher: 'Tüberküloz ve Toraks', 
    //  Subject: 'BİRİNCİ BASAMAK HEKİMLERİNİN AKCİĞER TÜBERKÜLOZU KONUSUNDA BİLGİ, TUTUM VE DAVRANIŞLARI İLE TEDAVİ YAKLAŞIMLARI'}
  ]
};

Infini.SampleData.KamClinicalTrial_01 = {
  data: [
    //{Id: 1, No: 'NCT01096875', Date: '2009-07-16T00:00:00', 
    //  Subject: 'Effects of Atorvastatin on Endothelial Progenitor Cells After Coronary Surgery', 
    //  Phase: 'Faz IV', Role: 'Lead R&D', Sponsor: 'Ankara Üniversitesi', Status: 'Aktif'},
    //{Id: 2, No: 'NCT00808288', Date: '2008-03-22T00:00:00', 
    //  Subject: 'A Study To Investigate The Safety, Toleration And Efficacy PF00610355 In Chronic', 
    //  Phase: 'Faz II', Role: 'Ekip', Sponsor: 'LORAX HEalth', Status: 'Kapandı'}
  ]
};

Infini.SampleData.KamClinicalTrial_02 = {
  data: [
    //{Id: 1, No: 'NCT00561769', Date: '2007-11-19T00:00:00', Subject: 'Luteal Phase Commencing of Growth Hormone', 
    //  Phase: 'Faz IV', Role: 'Team Lead', Sponsor: 'Gulhane School of Medicine', Status: 'Tamamlandı'},
    //{Id: 2, No: 'NCT00115297', Date: '2001-05-21T00:00:00', Subject: 'Montelukast for Early Life Wheezing', 
    //  Phase: 'Faz IV', Role: 'Team', Sponsor: 'Türk Kalp Vakfı', Status: 'İşe Alım'}
  ]
};

Infini.SampleData.KamSpeakerCompetence_01 = {
  data: [
    //{Id: 1, Date: '2009-03-22T00:00:00', Organization: 'Antalya Kongre', Role: 'Konuşmacı', 
    //  Subject: 'Effects of Atorvastatin on Endothelial Progenitor Cells After Coronary Surgery', GeneralAssessment: 'Mükemmel'}
  ]
};

Infini.SampleData.KamSpeakerCompetence_02 = {
  data: [
    //{Id: 1, Date: '2009-02-10T00:00:00', Organization: 'İzmir Kongre', Role: 'Konuşmacı', 
    //  Subject: 'Comparison of effects of darbepoetin alfa and epoetin alfa on serum endothelin level and blood pressure', GeneralAssessment: 'Orta'}
  ]
};

Infini.SampleData.CircleOfInfluence_KBB = {
  data: [
    //{Id: 1, InteractionType: 'Kişi', InteractionDirection: 1, EffectType: 'Birlikte Çalışıyor', Level: 'Güçlü', 
    //  CardOrLocation: 'Doç Dr Ali Taşpınarcıklı @ Cerrahpaşa Tıp Fakülteri KBB Servisi', StartDate: '2003-02-02T00:00:00'},
    //{Id: 2, InteractionType: 'Kurum', InteractionDirection: 1, EffectType: 'Klinik Şefi', Level: 'Orta', 
    //  CardOrLocation: 'Cerrahpaşa Tıp Fakülteri KBB Servisi', StartDate: '2001-06-07T00:00:00'},
    //{Id: 3, InteractionType: 'Kişi', InteractionDirection: 2, EffectType: 'Birlikte Çalışıyor', Level: 'Zayıf', 
    //  CardOrLocation: 'Prof Dr Murat Demirci @  Cerrahpaşa Tıp Fakülteri KBB Servisi', StartDate: '2003-02-02T00:00:00'}
  ]
};

Ext.ns('Infini.Base');
Ext.ns('Infini.Base.LocDef');
Ext.ns('Infini.Core');
Ext.ns('Infini.Core.LocDef');
Ext.ns('Infini.DevSupport');
Ext.ns('Infini.DevSupport.LocDef');

Infini.Base.LocDef.DecimalSeparator = ',';
Infini.Base.LocDef.DecimalGroupingSymbol = '.';
Infini.Base.LocDef.MainCurrencyCode = 'TL';

Infini.Base.LocDef.LoginCaption = 'Giriş';
Infini.Base.LocDef.UserName = 'Kullanıcı Adı';
Infini.Base.LocDef.Password = 'Şifre';
Infini.Base.LocDef.Language = 'Dil';
Infini.Base.LocDef.PleaseEnterVerificationCode = 'Lütfen cep telefonunuza gelen güvenlik kodunu giriniz:';
Infini.Base.LocDef.ForgotPassword = 'Şifremi Unuttum';
Infini.Base.LocDef.PleaseEnterYourEmailAddress = 'Lütfen sistemde kayıtlı e-posta adresinizi giriniz:';
Infini.Base.LocDef.PwdResetRequestHasBeenReceived = 'Kısa bir süre içinde e-posta adresinize şifre sıfırlama bağlantısı gönderilecektir.';
Infini.Base.LocDef.YourRequestIsBeingReceived = 'Talebiniz alınıyor...';
Infini.Base.LocDef.AnErrorOccuredWhileYourRequestIsBeingReceived = 'Talebiniz alınırken bir hata oluştu.';
Infini.Base.LocDef.ResetPasswordWithCode = 'Şifre Sıfırlama';
Infini.Base.LocDef.NewPassword = 'Yeni Şifre';
Infini.Base.LocDef.NewPasswordAgain = 'Yeni Şifre (tekrar)';
Infini.Base.LocDef.PasswordIsBeingReset = 'Şifre sıfırlanıyor...';
Infini.Base.LocDef.AnErrorOccuredWhileResettingPassword = 'Şifre sıfırlanırken bir hata oluştu.';
Infini.Base.LocDef.PasswordIsSuccessfullyReset = 'Şifre başarıyla sıfırlandı.';

Infini.Base.LocDef.VerificationCodeEntry = 'Güvenlik Kodu Girişi';
Infini.Base.LocDef.VerificationCode = 'Güvenlik Kodu';
Infini.Base.LocDef.RemainingTime = 'Kalan Süre';
Infini.Base.LocDef.VerificationCodeIsBeingAuthorized = 'Güvenlik Kodu onaylanıyor...';
Infini.Base.LocDef.AnErrorOccuredWhileVerificationCodeIsBeingAuthorized = 'Güvenlik Kodu onaylanırken bir hata oluştu.';

Infini.Base.LocDef.Yes = 'Evet';
Infini.Base.LocDef.No = 'Hayır';

Infini.Base.LocDef.WaitTitle = 'Lütfen bekleyin...';
Infini.Base.LocDef.Loading = 'Yükleniyor...';
Infini.Base.LocDef.ConfirmProceed = 'Devam etmek istiyor musunuz?';
Infini.Base.LocDef.ConfirmEnsuredProceed = 'Devam etmek istediğinizden emin misiniz?';
Infini.Base.LocDef.PercentComplete = '{0} % tamamlandı';
Infini.Base.LocDef.OperationIsInProgress = 'İşlem yapılıyor...';
Infini.Base.LocDef.OperationIsSuccessfullyCompleted = 'İşlem başarıyla tamamlandı.';
Infini.Base.LocDef.OperationCouldNotBeCompleted = 'İşlem tamamlanamadı.';

Infini.Base.LocDef.Records = 'Kayıtlar';
Infini.Base.LocDef.RecordCount = 'Kayıt Sayısı: {0}';
Infini.Base.LocDef.CannotFindEditedRecordWithId = 'Düzenlenen {0} \'{1}\' değerine sahip kayıt bulunamadı';


Infini.Base.LocDef.RecordCanNotBeLoaded = 'Kayıt yüklenemiyor.';

Infini.Base.LocDef.RecordIsBeingSaved = 'Kayıt kaydediliyor...';
Infini.Base.LocDef.RecordIsSuccessfullySaved = 'Kayıt başarıyla kaydedildi.';
Infini.Base.LocDef.RecordCanNotBeSaved = 'Kayıt kaydedilemedi.';

Infini.Base.LocDef.RecordIsBeingDeleted = 'Kayıt siliniyor...';
Infini.Base.LocDef.RecordIsSuccessfullyDeleted = 'Kayıt başarıyla silindi.';
Infini.Base.LocDef.RecordCanNotBeDeleted = 'Kayıt silinemedi.';

Infini.Base.LocDef.SelectedRecordIsBeingLoaded = 'Seçilen kayıt yükleniyor...';
Infini.Base.LocDef.SelectedRecordIsSuccessfullyLoaded = 'Seçilen kayıt başarıyla yüklendi.';
Infini.Base.LocDef.SelectedRecordCanNotBeLoaded = 'Seçilen kayıt yüklenemedi.';

Infini.Base.LocDef.RecordIsBeingUpdated = 'Kayıt düzenleniyor...';
Infini.Base.LocDef.RecordIsSuccessfullyUpdated = 'Kayıt başarıyla düzenlendi.';
Infini.Base.LocDef.ErrorWhileRecordWasBeingUpdated = 'Kayıt düzenlenirken bir hata oluştu.';

Infini.Base.LocDef.RecordIsBeingActivated = 'Kayıt aktifleştiriliyor...';
Infini.Base.LocDef.ErrorWhileEntityIsBeingActivated = 'Kayıt aktifleştirilirken bir hata oluştu.';

Infini.Base.LocDef.RecordIsBeingDeactivated = 'Kayıt pasifleştiriliyor...';
Infini.Base.LocDef.ErrorWhileEntityIsBeingDeactivated = 'Kayıt pasifleştirilirken bir hata oluştu.';

Infini.Base.LocDef.GenericIsBeingUpdated = '{0} düzenleniyor...';
Infini.Base.LocDef.GenericIsSuccessfullyUpdated = '{0} başarıyla düzenlendi.';
Infini.Base.LocDef.ErrorWhileGenericWasBeingUpdated = '{0} düzenlenirken bir hata oluştu.';

Infini.Base.LocDef.GenericStatusIsBeingUpdated = '{0} durumu değiştiriliyor...';
Infini.Base.LocDef.GenericStatusIsSuccessfullyUpdated = '{0} durumu başarıyla değiştirildi.';
Infini.Base.LocDef.ErrorWhileGenericStatusWasBeingUpdated = '{0} durumu değiştirilirken bir hata oluştu.';


Infini.Base.LocDef.RecordsAreBeingRetrieved = 'Kayıtlar yükleniyor...';
Infini.Base.LocDef.RecordsAreSuccessfullyRetrieved = 'Kayıtlar başarıyla yüklendi.';
Infini.Base.LocDef.ErrorWhileRecordsWereBeingRetrieved = 'Kayıtlar yüklenirken bir hata oluştu.';

Infini.Base.LocDef.RecordsAreBeingSaved = 'Kayıtlar kaydediliyor...';
Infini.Base.LocDef.ModifiedRecordsAreBeingSaved = 'Değişen kayıtlar kaydediliyor...';
Infini.Base.LocDef.ModifiedRecordsAreSuccessfullySaved = 'Değişen kayıtlar başarıyla kaydedildi.';
Infini.Base.LocDef.NumOfRecordsAreSuccessfullySaved = '<b>{0}</b> kayıt başarıyla kaydedildi.';
Infini.Base.LocDef.ErrorWhileRecordsWereBeingSaved = 'Kayıtlar kaydedilirken hata oluştu.';
Infini.Base.LocDef.ErrorNotAllRecordsWereSaved = 'Kayıtların hepsi kaydedilemedi.';

Infini.Base.LocDef.StatusOfSelectedRecordsAreBeingUpdated = 'Seçili kayıtların durumları değiştiriliyor...';
Infini.Base.LocDef.ErrorWhileStatusOfSelectedRecordsWereBeingUpdated = 'Seçili kayıtların durumları değiştirilirken bir hata oluştu.';
Infini.Base.LocDef.StatusOfSelectedRecordsAreSuccessfullyUpdated = 'Seçili kayıtların durumları başarıyla değiştirildi.';

Infini.Base.LocDef.RecordsAreBeingUpdated = 'Kayıtlar düzenleniyor...';
Infini.Base.LocDef.RecordsAreSuccessfullyUpdated = 'Kayıtlar başarıyla düzenlendi.';
Infini.Base.LocDef.ErrorWhileRecordsWereBeingUpdated = 'Kayıtlar düzenlenirken bir hata oluştu.';
Infini.Base.LocDef.CannotFindAnyRecordToBeUpdated = 'Listede düzenlenmesi gereken kayıt bulunamadı.';

Infini.Base.LocDef.FoundNoChangesToSave = 'Kaydedilmesi gereken değişiklik bulunamadı.';

Infini.Base.LocDef.MultipleSave = 'Birden fazla kayıt kaydetme';
Infini.Base.LocDef.MultipleSaveError = 'Kayıtların kayıdı sırasında hatalar alındı.<br/><br/>' +
                            'Kaydedilemeyen kayıt sayısı: {0},<br/>' +
                            'Kaydedilemeyen kayıtların numaraları: [{1}]';
Infini.Base.LocDef.MultipleSaveSummaryInfo = 'Yüklenen <b>{0}</b> kayıt içinden sadece <b>{1}</b> tanesi kaydedilmeye çalışılacak.' +
                                      '<br/><br/>Kayıt işlemine devam etmek istediğinizden emin misiniz?';

Infini.Base.LocDef.SaveChanges = 'Değişikliklerin Kaydedilmesi';
Infini.Base.LocDef.ConfirmSaveChanges = 'Değişiklikleri kaydetmek istiyor musunuz?';
Infini.Base.LocDef.ConfirmSaveTheseChanges = 'Değişiklikleri kaydetmek istiyor musunuz?';
Infini.Base.LocDef.ThereAreUnsavedChanges = 'Kaydedilmemiş değişiklikleriniz var.';
Infini.Base.LocDef.ThereAreUnsavedChangesOnRecord = 'Kayıtta değişiklikler yaptınız.';
Infini.Base.LocDef.ThereAreUnsavedChangesOnDetailRecord = 'Kayıt detayı kaydedilmemiş değişiklikler içeriyor.';
Infini.Base.LocDef.ConfirmCloseWithoutSave = 'Yapmış olabileceğiniz değişiklikleri kaydetmeden kapatmak istediğinizden emin misiniz?';

Infini.Base.LocDef.Calculated = 'Hesaplanan';
Infini.Base.LocDef.Calculate = 'Hesapla';
Infini.Base.LocDef.CalculateRatio = 'Oran Hesapla';
Infini.Base.LocDef.CalculationIsInProgress = 'Hesaplama yapılıyor...';
Infini.Base.LocDef.CalculationIsSuccessfullyCompleted = 'Hesaplama başarıyla tamamlandı.';
Infini.Base.LocDef.ErrorDuringCalculation = 'Hesaplama yapılırken bir hata oluştu.';


Infini.Base.LocDef.BatchEdit = 'Toplu Düzenleme';
Infini.Base.LocDef.ConfirmBatchEdit = '{0} kayıdı düzenlemek istediğinizden emin misiniz?';
Infini.Base.LocDef.RevertBackChangesOnField = 'Alandaki değişikliği geri al';
Infini.Base.LocDef.ClearField = 'Alanın değerini sil';
Infini.Base.LocDef.RecordsAreSuccessfullySaved = 'Kayıtlar başarıyla kaydedildi.';

Infini.Base.LocDef.RecordDeletion = 'Kayıt Silme';
Infini.Base.LocDef.ConfirmSelectedRecordsDeletion = 'Seçilen kayıtları silmek istediğinizden emin misiniz?';
Infini.Base.LocDef.SelectedRecordsAreBeingDeleted = 'Seçilen kayıtlar siliniyor...';
Infini.Base.LocDef.SelectedRecordsAreSuccessfullyDeleted = 'Seçilen kayıtlar başarıyla silindi.';
Infini.Base.LocDef.ErrorWhileRecordsWereBeingDeleted = 'Seçilen kayıtlar silinirken bir hata oluştu.';


Infini.Base.LocDef.And = 've';
Infini.Base.LocDef.User = 'Kullanıcı';
Infini.Base.LocDef.SystemUser = 'Sistem Kullanıcısı';
Infini.Base.LocDef.LastLoginDate = 'Son giriş tarihi';
Infini.Base.LocDef.Lists = 'Listeler';
Infini.Base.LocDef.Note = 'Not';
Infini.Base.LocDef.Notes = 'Notlar';
Infini.Base.LocDef.Note_01 = 'Not 1';
Infini.Base.LocDef.Note_02 = 'Not 2';
Infini.Base.LocDef.Note_03 = 'Not 3';
Infini.Base.LocDef.Actions = 'Aksiyonlar';
Infini.Base.LocDef.GeneralAssessment = 'Genel Değerlendirme';
Infini.Base.LocDef.Role = 'Rol';
Infini.Base.LocDef.Roles = 'Roller';
Infini.Base.LocDef.Permission = 'Yetki';
Infini.Base.LocDef.Permissions = 'Yetkiler';
Infini.Base.LocDef.Date = 'Tarih';
Infini.Base.LocDef.Day = 'Gün';
Infini.Base.LocDef.Week = 'Hafta';
Infini.Base.LocDef.Month = 'Ay';
Infini.Base.LocDef.Monthly = 'Aylık';
Infini.Base.LocDef.Year = 'Sene';
Infini.Base.LocDef.DayCount = 'Gün Sayısı';
Infini.Base.LocDef.ShortName = 'Kısa Ad';
Infini.Base.LocDef.FullName = 'Uzun Ad';
Infini.Base.LocDef.SeqNo = 'Sıra';
Infini.Base.LocDef.SortOrderNo = 'Sıra No';
Infini.Base.LocDef.BeginDate = 'Başlangıç';
Infini.Base.LocDef.EndDate = 'Bitiş';
Infini.Base.LocDef.TimeStart = 'Başlangıç';
Infini.Base.LocDef.TimeEnd = 'Bitiş';
Infini.Base.LocDef.Duration = 'Süre';
Infini.Base.LocDef.Male = 'Bay';
Infini.Base.LocDef.Female = 'Bayan';
Infini.Base.LocDef.MaleAbbr = 'B.';
Infini.Base.LocDef.FemaleAbbr = 'Bn.';
Infini.Base.LocDef.Code = 'Kod';
Infini.Base.LocDef.Description = 'Tanım';
Infini.Base.LocDef.Name = 'İsim';
Infini.Base.LocDef.Remark = 'Not';
Infini.Base.LocDef.Remarks = 'Notlar';
Infini.Base.LocDef.ItemRemark = 'Kalem Notları';
Infini.Base.LocDef.Label = 'Etiket';
Infini.Base.LocDef.Category = 'Kategori';
Infini.Base.LocDef.Category_01 = 'Kategori 1';
Infini.Base.LocDef.Category_02 = 'Kategori 2';
Infini.Base.LocDef.Category_03 = 'Kategori 3';
Infini.Base.LocDef.Section = 'Bölüm';
Infini.Base.LocDef.Sections = 'Bölümler';
Infini.Base.LocDef.Section_01 = 'Bölüm 1';
Infini.Base.LocDef.Section_02 = 'Bölüm 2';
Infini.Base.LocDef.Section_03 = 'Bölüm 3';
Infini.Base.LocDef.Title = 'Başlık';
Infini.Base.LocDef.Content = 'İçerik';
Infini.Base.LocDef.NumberAbbr = 'No';
Infini.Base.LocDef.SerialNo = 'Seri No';
Infini.Base.LocDef.Status = 'Durum';
Infini.Base.LocDef.StatusOpenClosed = 'Açık Durumu';
Infini.Base.LocDef.StatusChange = 'Durum Değişimi';
Infini.Base.LocDef.BatchStatusChange = 'Toplu Durum Değişimi';
Infini.Base.LocDef.StatusMgmt = 'Durum Yönetimi';
Infini.Base.LocDef.ExpirationDate = 'Son Kullanma Tarihi';
Infini.Base.LocDef.ValidFrom = 'Geçerlilik Tarihi';
Infini.Base.LocDef.ValidFrom2 = 'Başlangıç Tarihi';
Infini.Base.LocDef.ValidTo2 = 'Bitiş Tarihi';
Infini.Base.LocDef.AcceptanceDate = 'Kabul Tarihi';
Infini.Base.LocDef.EffectiveDate = 'Etkin Tarih';
Infini.Base.LocDef.ExpirationDate = 'Son Geçerlilik Tarihi';
Infini.Base.LocDef.Level = 'Seviye';
Infini.Base.LocDef.Step = 'Basamak';
Infini.Base.LocDef.Company = 'Firma';
Infini.Base.LocDef.Companies = 'Firmalar';
Infini.Base.LocDef.Duration_Minute = 'Süre (dak)';
Infini.Base.LocDef.DayPart = 'Zaman Dilimi';
Infini.Base.LocDef.Period = 'Dönem';
Infini.Base.LocDef.PeriodType = 'Dönem Tipi';
Infini.Base.LocDef.FromPeriod = 'Başlangıç Dönemi';
Infini.Base.LocDef.FromPeriodShort = 'Baş. Dönemi';
Infini.Base.LocDef.ToPeriod = 'Bitiş Dönemi';
Infini.Base.LocDef.PeriodStart = 'Dönem Başı';
Infini.Base.LocDef.PeriodEnd = 'Dönem Sonu';
Infini.Base.LocDef.PeriodCount = 'Dönem Sayısı';
Infini.Base.LocDef.DateInPeriod = 'Ara Tarih';
Infini.Base.LocDef.LessThanDays = '{0} günden az';
Infini.Base.LocDef.BetweenDays = '{0} ile {1} gün arasında';
Infini.Base.LocDef.MoreThanDays = '{0} günden fazla';
Infini.Base.LocDef.DateCanNotBeBeforePeriodBeginDate = '\'Tarih\' dönem başlangıç tarihinden küçük olamaz.';
Infini.Base.LocDef.DateCanNotBeAfterPeriodEndDate = '\'Tarih\' dönem bitiş tarihinden büyük olamaz.';
Infini.Base.LocDef.CannotFindActivePeriodRecord = 'Aktif dönem kayıdı bulunamadı.';
Infini.Base.LocDef.CannotFindPeriodRecord = '\'{0}\' kodlu dönem kayıdı bulunamadı';
Infini.Base.LocDef.CannotFindPeriodForTheSelectedDate = 'Seçilen tarih için tanımlı dönem bulunumadı.';
Infini.Base.LocDef.NumOfDigit = 'Basamak Sayısı';
Infini.Base.LocDef.MinOccurs = 'Min. Oluşum';
Infini.Base.LocDef.MaxOccurs = 'Maks. Oluşum';
Infini.Base.LocDef.Undefined = 'Tanımsız';

Infini.Base.LocDef.Version = 'Versiyon';
Infini.Base.LocDef.Channel = 'Kanal';
Infini.Base.LocDef.Source = 'Kaynak';
Infini.Base.LocDef.SourceName = 'Kaynak Adı';
Infini.Base.LocDef.Difference = 'Fark';
Infini.Base.LocDef.Discrepancy = 'Fark';
Infini.Base.LocDef.MappingType = 'Eşleşme Tipi';
Infini.Base.LocDef.MappingCode = 'Eşleşme Kodu';
Infini.Base.LocDef.Barcode = 'Barkod';
Infini.Base.LocDef.ProcessStatus = 'İşleme Durumu';
Infini.Base.LocDef.ProcessDate = 'Aktarım Tarihi';
Infini.Base.LocDef.DateOfData = 'Veri Tarihi';
Infini.Base.LocDef.ConstraintMode_Optional = 'Opsiyonel';
Infini.Base.LocDef.ConstraintMode_Mandatory = 'Zorunlu';
Infini.Base.LocDef.ConstraintMode_NotAllowed = 'İzin Verilmez';
Infini.Base.LocDef.Integration = 'Entegrasyon';
Infini.Base.LocDef.IntegrationNo = 'Entegrasyon No';
Infini.Base.LocDef.IntegrationCode = 'Entegrasyon Kodu';
Infini.Base.LocDef.IntegrationRemark = 'Entegrasyon Notu';
Infini.Base.LocDef.Valid = 'Geçerli';
Infini.Base.LocDef.Invalid = 'Geçersiz';
Infini.Base.LocDef.InvalidRecord = 'Geçersiz Kayıt';
Infini.Base.LocDef.InvalidDate = 'Geçersiz Tarih';

Infini.Base.LocDef.Card = 'Kişi';
Infini.Base.LocDef.Regions = 'Bölgeler';

Infini.Base.LocDef.System = 'Sistem';
Infini.Base.LocDef.General = 'Genel';
Infini.Base.LocDef.History = 'Tarihçe';
Infini.Base.LocDef.Summary = 'Özet';
Infini.Base.LocDef.Value = 'Değer';
Infini.Base.LocDef.Property = 'Özellik';
Infini.Base.LocDef.FromValue = 'Baş. Değeri';
Infini.Base.LocDef.OldValue = 'Eski Değer';
Infini.Base.LocDef.NewValue = 'Yeni Değer';
Infini.Base.LocDef.Score = 'Puan';
Infini.Base.LocDef.FinalScore = 'Toplam Puan';
Infini.Base.LocDef.GeneralScore = 'Genel Skor';
Infini.Base.LocDef.WeightedScore = 'Ağırlıklandırılmış Puan';
Infini.Base.LocDef.Plan = 'Plan';
Infini.Base.LocDef.Factor = 'Katsayı';
Infini.Base.LocDef.Weight = 'Ağırlık';
Infini.Base.LocDef.Tags = 'Etiket';


Infini.Base.LocDef.Active = 'Aktif';
Infini.Base.LocDef.Active_UC = 'AKTİF';
Infini.Base.LocDef.Passive = 'Pasif';
Infini.Base.LocDef.Passive_UC = 'PASİF';
Infini.Base.LocDef.Waiting = 'Bekliyor';
Infini.Base.LocDef.Verified = 'Kontrol Edildi';
Infini.Base.LocDef.NotVerified = 'Kontrol Edilmedi';
Infini.Base.LocDef.PreApproved = 'Ön Onaylandı';
Infini.Base.LocDef.Approved = 'Onaylandı';
Infini.Base.LocDef.Approved_2 = 'Onaylı';
Infini.Base.LocDef.Current = 'Yürürlükte';
Infini.Base.LocDef.Completed = 'Tamamlandı';
Infini.Base.LocDef.Processed = 'İşlendi';
Infini.Base.LocDef.Cancelled = 'İptal';
Infini.Base.LocDef.Erroneous = 'Hatalı';
Infini.Base.LocDef.DoNotShowInactives = 'Pasifleri gösterme';
Infini.Base.LocDef.Visible = 'Görünür';
Infini.Base.LocDef.ReadOnly = 'Salt Okunur';
Infini.Base.LocDef.InEvaluation = 'Değerlendirmede';
Infini.Base.LocDef.Started = 'Başlandı';
Infini.Base.LocDef.NotStarted = 'Başlanmadı';
Infini.Base.LocDef.WaitingApproval = 'Onay Bekliyor';
Infini.Base.LocDef.Rejected = 'Reddedildi';
Infini.Base.LocDef.Sent = 'Gönderildi';
Infini.Base.LocDef.Accepted = 'Kabul Edildi';
Infini.Base.LocDef.SentForApproval = 'Onaya Gönderildi';

Infini.Base.LocDef.Activate = 'Aktifleştir';
Infini.Base.LocDef.Deactivate = 'Pasifleştir';
Infini.Base.LocDef.Cancel = 'İptal Et';
Infini.Base.LocDef.Complete = 'Tamamla';
Infini.Base.LocDef.DeactivateAndCopy = 'Pasifleştir ve Kopyala';
Infini.Base.LocDef.AddOtherOption = 'Diğer Seçeneğini Ekle';
Infini.Base.LocDef.OtherOptionChoiceText = 'Diğer';
Infini.Base.LocDef.OpenForEvaluation = 'Değerlendirmeye Aç';
Infini.Base.LocDef.RevertApproval = 'Onayı Geri Al';
Infini.Base.LocDef.SendForApproval = 'Onaya Gönder ve Kapat';
Infini.Base.LocDef.Reopen = 'Yeniden Aç';
Infini.Base.LocDef.Allow = 'İzin Ver';
Infini.Base.LocDef.DoNotAllow = 'İzin Verme';

Infini.Base.LocDef.Cancelling = 'İptal Etme';
Infini.Base.LocDef.SendingForApproval = 'Onaya Gönderme';
Infini.Base.LocDef.OpeningForApproval = 'Onaya Açma';

Infini.Base.LocDef.Automatic = 'Otomatik';
Infini.Base.LocDef.Freeform = 'Serbest';
Infini.Base.LocDef.DefPool = 'Havuz';

Infini.Base.LocDef.Insufficient = 'Yetersiz';
Infini.Base.LocDef.Experienced = 'Tecrübeli';
Infini.Base.LocDef.Expert = 'Uzman';
Infini.Base.LocDef.Leader = 'Lider';


Infini.Base.LocDef.Type = 'Tip';
Infini.Base.LocDef.TypeCode = 'Tip Kodu';
Infini.Base.LocDef.Group = 'Grup';
Infini.Base.LocDef.Groups = 'Gruplar';
Infini.Base.LocDef.GroupCode = 'Grup Kodu';
Infini.Base.LocDef.GroupName = 'Grup Adı';
Infini.Base.LocDef.Kind = 'Tür';
Infini.Base.LocDef.ValueType = 'Değer Tipi';
Infini.Base.LocDef.MinMax = 'Min - Maks';

Infini.Base.LocDef.Add = 'Ekle';
Infini.Base.LocDef.Remove = 'Çıkar';

Infini.Base.LocDef.Back = 'Geri';
Infini.Base.LocDef.Forward = 'İleri';

Infini.Base.LocDef.Previous = 'Önceki';
Infini.Base.LocDef.Next = 'Sonraki';
Infini.Base.LocDef.Old = 'Eski';
Infini.Base.LocDef.New = 'Yeni';
Infini.Base.LocDef.Current = 'Güncel';
Infini.Base.LocDef.Unknown = 'Bilinmiyor';
Infini.Base.LocDef.Unknown_upper = 'BİLİNMİYOR';

Infini.Base.LocDef.Open = 'Açık';
Infini.Base.LocDef.Closed = 'Kapalı';
Infini.Base.LocDef.ToOpen = 'açmak';
Infini.Base.LocDef.ToClose = 'kapatmak';

Infini.Base.LocDef.Preview = 'Öngörünüm';
Infini.Base.LocDef.Reload = 'Yeniden yükle';
Infini.Base.LocDef.ExecuteQuery = 'Ara';
Infini.Base.LocDef.ShowList = 'Listele';
Infini.Base.LocDef.AddEntity = 'Yeni';
Infini.Base.LocDef.Edit = 'Düzenle';
Infini.Base.LocDef.Change = 'Değiştir';
Infini.Base.LocDef.Cancel = 'İptal';
Infini.Base.LocDef.Delete = 'Sil';
Infini.Base.LocDef.DeleteAll = 'Hepsini sil';
Infini.Base.LocDef.Save = 'Kaydet';
Infini.Base.LocDef.SaveAll = 'Tümünü Kaydet';
Infini.Base.LocDef.SaveAndClose = 'Kaydet & Kapat';
Infini.Base.LocDef.SaveAndVerify = 'Kaydet & Kontrol Et';
Infini.Base.LocDef.Copy = 'Kopyala';
Infini.Base.LocDef.CopyValue = 'Değeri Kopyala';
Infini.Base.LocDef.ShowForm = 'Formunu göster';
Infini.Base.LocDef.ClearCriteria = 'Kriterleri sıfırla';
Infini.Base.LocDef.Reset = 'Sıfırla';
Infini.Base.LocDef.Process = 'İşle';
Infini.Base.LocDef.Approve = 'Onayla';
Infini.Base.LocDef.ApproveAndClose = 'Onayla & Kapat';
Infini.Base.LocDef.Reject = 'Reddet';
Infini.Base.LocDef.SelectedItem = 'Seçilen';
Infini.Base.LocDef.Folder = 'Klasör';
Infini.Base.LocDef.LocateInFolder = 'Klasöre git';
Infini.Base.LocDef.File = 'Dosya';
Infini.Base.LocDef.Files = 'Dosyalar';
Infini.Base.LocDef.Upload = 'Yükle';
Infini.Base.LocDef.UploadFile = 'Dosya Yükle';
Infini.Base.LocDef.UploadImage = 'Resmi Yükle';
Infini.Base.LocDef.Download = 'İndir';
Infini.Base.LocDef.ViewOrDownload = 'Göster\\İndir';
Infini.Base.LocDef.Start = 'Başlat';
Infini.Base.LocDef.Finish = 'Bitir';
Infini.Base.LocDef.Revert = 'Geri Al';
Infini.Base.LocDef.Send = 'Gönder';
Infini.Base.LocDef.SendBack = 'Geri Gönder';
Infini.Base.LocDef.Size = 'Boyut';
Infini.Base.LocDef.RealDimensions = 'Gerçek Boyutlar';

Infini.Base.LocDef.Remote = 'Uzaktan';
Infini.Base.LocDef.Participant = 'Katılımcı';
Infini.Base.LocDef.FieldActivity = 'Saha Aktivitesi';
Infini.Base.LocDef.ExemptFromFieldActivity = 'Saha Matrahından Muaf';

Infini.Base.LocDef.Created = 'Oluşturulma';
Infini.Base.LocDef.CreatedBy = 'Oluşturan';
Infini.Base.LocDef.CreatedOn = 'Oluşturulma Tarihi';
Infini.Base.LocDef.ModifiedBy = 'Değiştiren';
Infini.Base.LocDef.ModifiedOn = 'Değiştirilme Tarihi';

Infini.Base.LocDef.FormIsOpening = 'Form açılıyor...';
Infini.Base.LocDef.FormNo = 'Form No';
Infini.Base.LocDef.FormName = 'Form Adı';
Infini.Base.LocDef.SessionIsStarting = 'Oturum açılıyor...';
Infini.Base.LocDef.SessionCanNotBeStarted = 'Oturum açılamadı.';

Infini.Base.LocDef.Error = 'Hata';
Infini.Base.LocDef.Errors = 'Hatalar';
Infini.Base.LocDef.ErrorMessage = 'Hata Mesajı';
Infini.Base.LocDef.RecordErrors = 'Kayıt Hataları';

Infini.Base.LocDef.ExportToExcel = 'Excel\'e gönder';
Infini.Base.LocDef.ExportResultsToExcel = 'Sonuçları Excel\'e gönder';
Infini.Base.LocDef.ExportDetailsToExcel = 'Detayları Excel\'e aktar';
Infini.Base.LocDef.ExportDataIsBeingPrepared = 'Veriler hazırlanıyor...';
Infini.Base.LocDef.ExportDataCanNotBePrepared = 'Veriler hazırlanamadı.';

Infini.Base.LocDef.DataIsSuccessfullyCopied = 'Veriler başarıyla kopyalandı.';

Infini.Base.LocDef.Criterion = 'Kriter';
Infini.Base.LocDef.Criteria = 'Kriterler';
Infini.Base.LocDef.AdvanceCriteria = 'Detaylı Arama Kriterleri';

Infini.Base.LocDef.ExpandAll = 'Tümünü Genişlet';
Infini.Base.LocDef.CollapseAll = 'Tümünü Daralt';
Infini.Base.LocDef.All = 'Tümü';
Infini.Base.LocDef.All2 = '(Tümü)';
Infini.Base.LocDef.All3 = '(TÜMÜ)';
Infini.Base.LocDef.None = 'Hiçbiri';
Infini.Base.LocDef.Blanks = '(Boş olanlar)';
Infini.Base.LocDef.Nonblanks = '(Boş olmayanlar)';
Infini.Base.LocDef.AddedItems = 'Eklenenler';
Infini.Base.LocDef.RemovedItems = 'Çıkarılanlar';
Infini.Base.LocDef.UnchangedItems = 'Değişmeyenler';
Infini.Base.LocDef.WaitingOnes = 'Bekleyenler';
Infini.Base.LocDef.CompletedOnes = 'Tamamlananlar';
Infini.Base.LocDef.NewList = 'Yeni Liste';
Infini.Base.LocDef.Total = 'Toplam';
Infini.Base.LocDef.Whole = 'Tam';
Infini.Base.LocDef.Average = 'Ortalama';
Infini.Base.LocDef.Average2 = 'Orta';
Infini.Base.LocDef.Min_abbr = 'Min.';
Infini.Base.LocDef.Max_abbr = 'Maks.';
Infini.Base.LocDef.AppliedToTotal = 'Toplama Uygulanır';
Infini.Base.LocDef.Remaining = 'Kalan';
Infini.Base.LocDef.Total_MainCurrency = String.format('Toplam {0}', Infini.Base.LocDef.MainCurrencyCode);
Infini.Base.LocDef.PercSign = '%';
Infini.Base.LocDef.RatioPerc = 'Oran (%)';
Infini.Base.LocDef.Distribution = 'Dağılım';
Infini.Base.LocDef.Constant = 'Sabit';
Infini.Base.LocDef.Variable = 'Değişken';
Infini.Base.LocDef.Result = 'Sonuç';
Infini.Base.LocDef.MaxValue = 'Maksimum Değer';
Infini.Base.LocDef.Document = 'Belge';
Infini.Base.LocDef.Documents = 'Belgeler';
Infini.Base.LocDef.Draft = 'Taslak';
Infini.Base.LocDef.ReferenceOperation = 'Referans İşlem';

Infini.Base.LocDef.RetrievingDefaultValuesOfNewRecord = 'Varsayılan yeni kayıt öğreniliyor...';

Infini.Base.LocDef.Icon = 'İkon';
Infini.Base.LocDef.Detail = 'Detay';
Infini.Base.LocDef.Details = 'Detaylar';
Infini.Base.LocDef.DesktopShortcuts = 'Masaüstü Kısayolları';
Infini.Base.LocDef.DesktopShortcuts_Descr = 'Masaüstünde hangi kısayolların gözükmesini istediğinizi seçebilirsiniz';
Infini.Base.LocDef.DesktopShortcuts_Descr2 = 'Seçilen fonksiyonlar için masaüstü kısayolu eklenecektir.';
Infini.Base.LocDef.AutomaticModuleRun = 'Otomatik Çalıştırma';
Infini.Base.LocDef.AutomaticModuleRun_Descr = 'Sisteme giriş yaptığınızda otomatik olarak çalışmasını istediğiniz fonksiyonları seçebilirsiniz';
Infini.Base.LocDef.AutomaticModuleRun_Descr2 = 'Seçilen fonksiyonlar sisteme giriş yaptığınızda otomatik olarak çalıştırılacaktır.';
Infini.Base.LocDef.QuickStartMenu = 'Hızlı Başlangıç Menüsü';
Infini.Base.LocDef.QuickStartMenu_Descr = 'Hızlı Başlangıç Menüsünde hangi kısayolların gözükmesini istediğinizi seçebilirsiniz';
Infini.Base.LocDef.QuickStartMenu_Descr2 = 'Seçilen fonksiyonların kısayolları Hızlı Başlangıç Menüsünde gösterilecektir.';
Infini.Base.LocDef.View = 'Görünüm';
Infini.Base.LocDef.DesktopView_Descr = 'Pencerelerinizin renklerini ve stillerini ayarlayabilirsiniz';
Infini.Base.LocDef.DesktopSettings = 'Masaüstü';
Infini.Base.LocDef.DesktopSettings_Descr = 'Masaüstünüzün duvar kağıdını ve renklerini değiştirebilirsiniz';
Infini.Base.LocDef.Theme_LightGreen = 'Açık Yeşil';
Infini.Base.LocDef.Theme_Blue = 'Mavi';
Infini.Base.LocDef.Theme_Grey = 'Gri';
Infini.Base.LocDef.Theme_Accessibility = 'Gri';
Infini.Base.LocDef.Background = 'Arka Plan';
Infini.Base.LocDef.BackgroundColor = 'Arka Plan rengi';
Infini.Base.LocDef.SelectBackgroundColor = 'Arka Plan rengi seçiniz';
Infini.Base.LocDef.WallpaperPosition = 'Duvar Kağıdının Pozisyonu';

Infini.Base.LocDef.Color = 'Renk';
Infini.Base.LocDef.PickFontColor = 'Yazı tipi rengi seçiniz';
Infini.Base.LocDef.FontColor = 'Yazı tipi rengi';
Infini.Base.LocDef.TaskbarTransparency = 'Görev Çubuğu Saydamlığı';

Infini.Base.LocDef.DefaultSettings = 'Varsayılan ayarlar';
Infini.Base.LocDef.ResetWindowToDefaults = 'Pencere ayarlarını varsayılanlara sıfırla';
Infini.Base.LocDef.ResetWindowToDefaultsConfirm = 'Pencereyi varsayılan ayarlarına döndürmek istediğinizden emin misiniz?';

Infini.Base.LocDef.DefaultSettingsForRole = 'Rol için varsayılan ayarlar';
Infini.Base.LocDef.SaveSettingsAsDefaultForRole = 'Ayarları \'{0}\' rolü için kaydet';
Infini.Base.LocDef.SaveCurrentWindowSettingsAsDefaultForRole = 'Pencere ayarlarını sahip olunan rol için varsayılan sistem özelleştirmesi olarak kaydet';
Infini.Base.LocDef.SaveCurrentWindowSettingsAsDefaultForRoleConfirm = 'Pencere ayarlarını {0} rolü için varsayılan sistem özelleştirmesi olarak kaydetmek ' +
  'istediğinizden emin misiniz?';
Infini.Base.LocDef.SaveCurrentWindowSettingsAsDefaultForRoleWaitMessage = 'Pencere ayarları {0} rolü için varsayılan sistem özelleştirmesi olarak kaydediliyor.';
Infini.Base.LocDef.SaveCurrentWindowSettingsAsDefaultForRoleSuccessMessage = 'Pencere ayarları {0} rolü için varsayılan sistem özelleştirmesi olarak başarıyla kaydedildi.';
Infini.Base.LocDef.SaveCurrentWindowSettingsAsDefaultForRoleFailureMessage = 'Pencere ayarları {0} rolü için varsayılan sistem özelleştirmesi olarak kaydedilirken ' +
  'bir hata oluştu.';
Infini.Base.LocDef.ToggleCriteria = 'Kriterleri sakla/göster';

Infini.Base.LocDef.OK = 'Tamam';
Infini.Base.LocDef.Help = 'Yardım';
Infini.Base.LocDef.ExtensiveHelp = 'Kapsamlı Yardım';

Infini.Base.LocDef.Record = 'Kayıt';
Infini.Base.LocDef.Unselect = 'Seçimi kaldır';
Infini.Base.LocDef.Tool = 'Araç';
Infini.Base.LocDef.Other = 'Diğer';

Infini.Base.LocDef.DayShort = 'g';
Infini.Base.LocDef.HourShort = 'sa';
Infini.Base.LocDef.MinuteShort = 'dak';
Infini.Base.LocDef.SecondShort = 'sn';
Infini.Base.LocDef.DaysFromToday = 'Bugünden İleri';
Infini.Base.LocDef.PrevDay = 'Önceki Gün';
Infini.Base.LocDef.NextDay = 'Sonraki Gün';

Infini.Base.LocDef.Before = 'önce';
Infini.Base.LocDef.After = 'sonra';

Infini.Base.LocDef.Months = 'Aylar';
Infini.Base.LocDef.Quarters = 'Çeyrekler';
Infini.Base.LocDef.HalfYears = 'Yarı Yıllar';
Infini.Base.LocDef.Years = 'Yıllar';
Infini.Base.LocDef.Days = 'Günler';

Infini.Base.LocDef.CharacterCount = 'Character Count';

Infini.Base.LocDef.Instruction = 'Açıklama';
Infini.Base.LocDef.Instruction1 = 'Açıklama 1';
Infini.Base.LocDef.Instruction2 = 'Açıklama 2';
Infini.Base.LocDef.Instruction3 = 'Açıklama 3';
Infini.Base.LocDef.Subject = 'Konu';
Infini.Base.LocDef.Information = 'Bilgi';
Infini.Base.LocDef.ProcessInProgress = 'İşlem Devam Ediyor';
Infini.Base.LocDef.ProcessComplete = 'İşlem Tamamlandı';
Infini.Base.LocDef.Warning = 'Uyarı';
Infini.Base.LocDef.Warnings = 'Uyarılar';
Infini.Base.LocDef.Confirmation = 'Onaylama';

Infini.Base.LocDef.Work = 'Çalışma';
Infini.Base.LocDef.Unit = 'Birim';

Infini.Base.LocDef.Small = 'Küçük';
Infini.Base.LocDef.Medium = 'Orta';
Infini.Base.LocDef.MediumSize = 'Orta Boy';
Infini.Base.LocDef.Large = 'Büyük';


Infini.Base.LocDef.FindSimilars = 'Benzerlerini Bul';
Infini.Base.LocDef.SaveRevisedChanges = 'Seçilen değişiklikleri kaydet';
Infini.Base.LocDef.SaveRevisedChangesWaitMessage = 'Seçilen değişiklikler kaydediliyor...';
Infini.Base.LocDef.SaveRevisedChangesFailureMessage = 'Seçilen değişiklikler kaydedilemedi.';
Infini.Base.LocDef.SaveRevisedChangesSuccessMessage = 'Seçilen değişiklikler başarıyla kaydedildi.';
Infini.Base.LocDef.UnrevisedFields = 'Seçim yapılmamış alanlar';
Infini.Base.LocDef.UnrevisedFieldsExists = '"{0}" alan(lar)ı için seçim yapılmadı.';
Infini.Base.LocDef.UnchangedFields = 'Değişmeyecek alanlar';
Infini.Base.LocDef.ChangedFields = 'Değişecek alanlar';
Infini.Base.LocDef.ClearedFields = 'Silinecek alanlar';
Infini.Base.LocDef.Reason = 'Neden';
Infini.Base.LocDef.AdjReason = 'Düzenleme Nedeni';
Infini.Base.LocDef.ReasonDescr = 'Neden Tanımı';
Infini.Base.LocDef.RejectionReason = 'Reddetme Nedeni';


Infini.Base.LocDef.Report = 'Rapor';
Infini.Base.LocDef.FirstPage = 'İlk Sayfa';
Infini.Base.LocDef.PreviousPage = 'Önceki Sayfa';
Infini.Base.LocDef.NextPage = 'Sonraki Sayfa';
Infini.Base.LocDef.LastPage = 'Son Sayfa';
Infini.Base.LocDef.PageWidth = 'Sayfa Genişliği';
Infini.Base.LocDef.WholePage = 'Tüm Sayfa';
Infini.Base.LocDef.ShowReport = 'Raporu Göster';
Infini.Base.LocDef.ShowPrevReport = 'Önceki Raporu Göster';
Infini.Base.LocDef.ShowNextReport = 'Sonraki Raporu Göster';
Infini.Base.LocDef.ReportIsBeingPrepared = 'Rapor hazırlanıyor...';
Infini.Base.LocDef.AnErrorOccuredWhileReportIsBeingPrepared = 'Rapor hazırlanırken bir hata oluştu.';
Infini.Base.LocDef.ReportCanNotBeRendered = 'Rapor gösterilemiyor.';
Infini.Base.LocDef.ReportCanNotBeExported = 'Rapor dışarıya aktarılamıyor.';

Infini.Base.LocDef.Export = 'Gönder';
Infini.Base.LocDef.Refresh = 'Yenile';
Infini.Base.LocDef.Print = 'Yazdır';

Infini.Base.LocDef.Action = 'İşlem';
Infini.Base.LocDef.Action2 = 'Aksiyon';
Infini.Base.LocDef.List = 'Liste';
Infini.Base.LocDef.Lists = 'Listeler';
Infini.Base.LocDef.ListType = 'Liste Tipi';
Infini.Base.LocDef.SmartSearch = 'Akıllı Arama';
Infini.Base.LocDef.QuickSearch = 'Hızlı Arama';
Infini.Base.LocDef.SearchingText = 'Aranıyor...';


Infini.Base.LocDef.PageDesign = 'Sayfa tasarımı';


Infini.Base.LocDef.Start = 'Başla';
Infini.Base.LocDef.Logout = 'Güvenli Çıkış';
Infini.Base.LocDef.AcquiringUserInformation = 'Kullanıcı bilgileri öğreniliyor...';
Infini.Base.LocDef.UnsupportedBrowserVersion_Title = 'Düşük Tarayıcı Sürümü';
Infini.Base.LocDef.UnsupportedBrowserVersion = 'Kullandığınız tarayıcı sürümü bu uygulamanın sorunsuz ve etkin çalışması için yeterli değildir. ' +
  'Uygulamanın desteklediği tarayıcı ve sürümleri: Chrome 30+, Firefox (Gecko) 20+, Internet Explorer 9+';
Infini.Base.LocDef.BrowserIncompatibility = 'Tarayıcı Uyumsuzluğu';
Infini.Base.LocDef.BrowserIncompatibility_FormData = 'Kullandığınız tarayıcı parçalı dosya yükleme işlemi için gereken altyapıyı desteklememektedir.<br/>' +
  'Altyapıyı destekleyen tarayıcılar: Chrome 30+, Firefox (Gecko) 20+, Internet Explorer 10+, Opera 12+, Safari 5+';
Infini.Base.LocDef.BrowserIncompatibility_FormData2 = 'Parçalı dosya yükleme işlemi bu tarayıcı sürümü tarafından deskteklenmemektedir.';
Infini.Base.LocDef.BrowserIncompatibility_FormData_Resolution = 'Mümkünse tarayıcınızın güncel sürümünü yükleyiniz. Eğer mümkün değil ise tavsiye edilmemekle birlikte ' +
  'dosyayı normal olarak yükleyebilirsiniz.<br/><br/>Dosyayı bu şekilde yüklemek ister misiniz?';

Infini.Base.LocDef.UnexpectedErrorOccurredTryAgain = 'Beklenmeyen bir hata ile karşılaşıldı. Lütfen tekrar deneyiniz.';
Infini.Base.LocDef.AnErrorOccurredOnTheServerSide = 'İstemci tarafında bir hata oluştu.';
Infini.Base.LocDef.FollowingErrorsOccurredDuringPopulatingDirectLookups = 'Giriş sırasında okunan verilerin istenmesi sırasında aşağıdaki hatalarla karşılaşıldı.';

Infini.Base.LocDef.RestoreWindow = 'Önceki Boyut';
Infini.Base.LocDef.MinimizeWindow = 'Simge Durumuna Küçült';
Infini.Base.LocDef.MaximizeWindow = 'Ekranı Kapla';
Infini.Base.LocDef.FitWindow = 'Masaüstü Boyutuna Sığdır';
Infini.Base.LocDef.Close = 'Kapat';

Infini.Base.LocDef.MinimizeAll = 'Tüm pencereleri simge Durumuna Küçült';
Infini.Base.LocDef.MaximizeAll = 'Tümünü Simge Durumuna Küçült';
Infini.Base.LocDef.FitAll = 'Tümünü Masaüstü Boyutuna Sığdır';
Infini.Base.LocDef.CloseAll = 'Tümünü Kapat';

Infini.Base.LocDef.Favorite = 'Favori';
Infini.Base.LocDef.AddToFavorites = 'Favorilere ekle';
Infini.Base.LocDef.RemoveFromFavorites = 'Favorilerden çıkar';

Infini.Base.LocDef.ShowToolPanel = 'Araç panelini göster';
Infini.Base.LocDef.HideToolPanel = 'Araç panelini sakla';

Infini.Base.LocDef.OperationComplete = 'İşlem tamam';
Infini.Base.LocDef.WallpaperIsLoaded = 'Duvar kağıdı yüklendi.';
Infini.Base.LocDef.WallpaperIsBeingLoaded = 'Duvar kağıdı yükleniyor...';

Infini.Base.LocDef.MinimumCharsRequiredToSearch = 'Arama için en az {0} karakter girin...';
Infini.Base.LocDef.MinimumFourCharsRequiredToSearch = String.format(Infini.Base.LocDef.MinimumCharsRequiredToSearch, 4);

Infini.Base.LocDef.FileName = 'Dosya İsmi';
Infini.Base.LocDef.FileDate = 'Dosya Tarihi';
Infini.Base.LocDef.TemplateName = 'Veri Şablonu';
Infini.Base.LocDef.DownloadFile = 'Dosyayı İndir';
Infini.Base.LocDef.DownloadSampleFile = 'Örnek Dosyayı İndir';
Infini.Base.LocDef.DownloadRequestFile = 'Talep Dosyasını İndir';
Infini.Base.LocDef.DownloadImage = 'Resmi İndir';
Infini.Base.LocDef.ViewFile = 'Dosyayı Göster';
Infini.Base.LocDef.DeleteFile = 'Dosyayı Sil';
Infini.Base.LocDef.ProcessFile = 'Dosyayı İşle';
Infini.Base.LocDef.DeleteImage = 'Resmi Sil';
Infini.Base.LocDef.DeletingImage = 'Resim siliniyor...';
Infini.Base.LocDef.FileProcessInformation = 'Dosya Aktarım Bilgileri';
Infini.Base.LocDef.FileImportError = 'Dosya aktarım hatası';
Infini.Base.LocDef.FileProcessError = 'Dosya işleme hatası';
Infini.Base.LocDef.FileImportQueued = 'Aktarım sırada bekliyor';
Infini.Base.LocDef.FileImportRunning = 'Aktarım çalışıyor...';
Infini.Base.LocDef.AnActiveTemplateRecordCanNotBeFound = 'Aktif şablon kayıdı bulunamadı.';
Infini.Base.LocDef.DataTemplateParameters = 'Veri Şablonu Parametreleri';
Infini.Base.LocDef.ZipSelectedFile = 'Seçili dosyayı sıkıştır';
Infini.Base.LocDef.FileIsBeingCompressed = 'Dosya sıkıştırılıyor...';
Infini.Base.LocDef.SuccessfulImport = 'Hatasız Aktarım';
Infini.Base.LocDef.UnsuccessfulImport = 'Hatalı Aktarım';
Infini.Base.LocDef.DoubleImport = 'Mükerrer Aktarım';


Infini.Base.LocDef.FileUpload = 'Dosya Yükleme';
Infini.Base.LocDef.UploadDate = 'Yükleme Tarihi';

Infini.Base.LocDef.FileIsBeingUploaded = 'Dosya yükleniyor...';
Infini.Base.LocDef.ErrorWhileFileWasBeingUploaded = 'Dosya yüklenirken bir hata oluştu.';
Infini.Base.LocDef.FileIsSuccessfullyUploaded = 'Dosya yükleme işlemi başarıyla tamamlandı.';

Infini.Base.LocDef.ChunkedFileUploadProcessIsBeingStarted = 'Parçalı dosya yükleme işlemi başlatılıyor...';
Infini.Base.LocDef.ErrorWhileChunkedFileUploadProcessWasBeingStarted = 'Parçalı dosya yükleme işlemi başlatılırken bir hata oluştu.';
Infini.Base.LocDef.ChunkedFileUploadProcessIsSuccessfullyCompleted = 'Parçalı dosya yükleme işlemi başarıyla tamamlandı.';

Infini.Base.LocDef.ChunkedFileIsBeingUploaded = 'Parçalı dosya yükleniyor...';
Infini.Base.LocDef.ErrorWhileChunkedFileWasBeingUploaded = 'Parçalı dosya yüklenirken bir hata oluştu.';

Infini.Base.LocDef.FileUploadControlIsInProgress = 'Dosya yükleme kontrolü yapılıyor...';
Infini.Base.LocDef.ErrorDuringFileUploadControl = 'Dosya yükleme kontrolü yapılırken bir hata oluştu.';

Infini.Base.LocDef.CatalogIsBeingCreatedForChunkedFiles = 'Parçalı dosyalar için katalog yaratılıyor...';
Infini.Base.LocDef.ErrorWhileCatalogIsBeingCreatedForChunkedFiles = 'Parçalı dosyalar için katalog yaratılırken bir hata oluştu.';

Infini.Base.LocDef.FollowingErrorsFoundWhileVerifyingTheFile = 'Dosya kontrol edilirken aşağıda belirtilen hata(lar) bulundu.';


Infini.Base.LocDef.FileIsBeingDownloaded = 'Dosya indiriliyor...';
Infini.Base.LocDef.ErrorWhileFileWasBeingDownloaded = 'Dosya indirilirken bir hata oluştu.';


Infini.Base.LocDef.OpenSelectedPeriod = 'Seçili Dönemi Aç';
Infini.Base.LocDef.CloseSelectedPeriod = 'Seçili Dönemi Kapat';
Infini.Base.LocDef.OpeningPeriod = 'Dönem açılıyor...';
Infini.Base.LocDef.ClosingPeriod = 'Dönem kapatılıyor...';
Infini.Base.LocDef.AnErrorOccuredWhilePeriodStatusChange = 'Dönem durumu değiştirilirken bir hata oluştu.';
Infini.Base.LocDef.PeriodIsSuccessfullyOpened = 'Dönem başarıyla açıldı.';
Infini.Base.LocDef.PeriodIsSuccessfullyClosed = 'Dönem başarıyla kapatıldı.';
Infini.Base.LocDef.PeriodStatusCheckIsInProgress = 'Dönem durumu kontrol ediliyor...';
Infini.Base.LocDef.AnErrorOccuredDuringPeriodStatusCheck = 'Dönem durumu kontrol edilirken bir hata oluştu.';
Infini.Base.LocDef.NoOperationCanBeMadeForThePastPeriods = 'Geçmiş dönemler için işlem yapılamaz.';


Infini.Base.LocDef.SelectedEntityRecords = 'Seçilen {0} <b>{1}</b> kayıdını';
Infini.Base.LocDef.SelectedRecords = 'Seçilen {0} kayıdı';
Infini.Base.LocDef.SelectedEntityRecord = '<b>{0}</b> kayıdını';
Infini.Base.LocDef.SelectedRecord = 'Kayıdı';

Infini.Base.LocDef.ConfirmDelete = ' silmek istediğinizden emin misiniz?';
Infini.Base.LocDef.ConfirmRecordDelete = 'Kayıdı silmek istediğinizden emin misiniz?';
Infini.Base.LocDef.EntityIsBeingDeleted = '{0} siliniyor...';
Infini.Base.LocDef.ErrorWhileEntityIsBeingDeleted = '{0} silinirken hata oluştu.';
Infini.Base.LocDef.EntityIsSuccessfullyDeleted = '{0} başarıyla silindi.';

Infini.Base.LocDef.SelectedItemIsBeingDeleted = 'Seçilen {0} siliniyor...';
Infini.Base.LocDef.SelectedItemCanNotBeDeleted = 'Seçilen {0} silinemedi.';
Infini.Base.LocDef.SelectedItemIsSuccessfullyDeleted = 'Seçilen {0} başarıyla silindi.';


Infini.Base.LocDef.RecordIsBeingApproved = 'Kayıt onaylanıyor...';
Infini.Base.LocDef.RecordCouldNotBeApproved = 'Kayıt onaylanamadı.';
Infini.Base.LocDef.RecordWasApproved = 'Kayıt onaylandı.';

Infini.Base.LocDef.RecordIsBeingSentBack = 'Kayıt geri gönderiliyor...';
Infini.Base.LocDef.RecordCouldNotBeSentBack = 'Kayıt geri gönderilemedi.';
Infini.Base.LocDef.RecordWasSentBack = 'Kayıt geri gönderildi.';


Infini.Base.LocDef.FileIsBeingProcessed = 'Dosya işleniyor...';
Infini.Base.LocDef.ErrorWhileFileIsBeingProcessed = 'Dosya işlenirken bir hata oluştu.';

Infini.Base.LocDef.FileProcessCheckIsInProgress = 'Dosya işleme kontrolü yapılıyor...';
Infini.Base.LocDef.ErrorWhileFileProcessCheck = 'Dosya işleme kontrolü yapılırken bir hata oluştu.';

Infini.Base.LocDef.FileDeleteCheckIsInProgress = 'Dosya silme kontrolü yapılıyor...';
Infini.Base.LocDef.ErrorWhileCheckingFileDelete = 'Dosya silme kontrolü yapılırken bir hata oluştu...';


Infini.Base.LocDef.FilesAreBeingProcessed = 'Dosyalar işleniyor...';
Infini.Base.LocDef.ErrorWhileFilesWereBeingProcessed = 'Dosyalar işlenirken bir hata oluştu.';

Infini.Base.LocDef.FilesAreBeingDeleted = 'Dosyalar siliniyor...';
Infini.Base.LocDef.ErrorWhileFilesWereBeingDeleted = 'Dosyalar silinirken bir hata oluştu.';

Infini.Base.LocDef.FileProcessChecksAreInProgress = 'Dosya işleme kontrolleri yapılıyor...';
Infini.Base.LocDef.ErrorWhileCheckingFileProcesses = 'Dosya işleme kontrolleri yapılırken bir hata oluştu.';

Infini.Base.LocDef.FileDeleteChecksAreInProgress = 'Dosya silme kontrolleri yapılıyor...';
Infini.Base.LocDef.ErrorWhileCheckingFileDeletes = 'Dosya silme kontrolleri yapılırken bir hata oluştu...';


Infini.Base.LocDef.SelectedRecordsCheckSummary = 'Seçilen {0} kayıttan {1} tanesi hata, {2} tanesi uyarı vermiştir.';
Infini.Base.LocDef.NoActionWillBeTakenForRecordsWithError = 'Hata mesajı veren {0} kayıt için işlem yapılmayacaktır.';
Infini.Base.LocDef.ConfirmProceedWithRecordsWithWarning = 'Uyarı mesajı veren {0} kayıt ile işleme devam etmek istiyor musunuz?';
Infini.Base.LocDef.ConfirmProceedWithRecordsWithWarningAndSuccess = 'Uyarı mesajı veren {0} ve kalan {1} kayıt ile işleme devam etmek istiyor musunuz?';
Infini.Base.LocDef.ConfirmProceedWithRecordsWithSuccess = 'Kalan {0} kayıt ile işleme devam etmek istiyor musunuz?';


Infini.Base.LocDef.ConfirmBatchStatusChange = 'Listelenen {0} kayıdı {1} istediğinizden emin misiniz?';


Infini.Base.LocDef.HolidaysAreBeingRetrieved = 'Tatil günleri öğreniliyor';

Infini.Base.LocDef.Message = 'Mesaj';
Infini.Base.LocDef.Messages = 'Mesajlar';
Infini.Base.LocDef.SendingMessage = 'Mesaj Gönderme';
Infini.Base.LocDef.ShowMessage = 'Mesajı Göster';
Infini.Base.LocDef.ManageMessage = 'Mesajı Yönet';
Infini.Base.LocDef.Sender = 'Gönderen';
Infini.Base.LocDef.MessageIsBeingSent = 'Mesaj gönderiliyor...';
Infini.Base.LocDef.ErrorWhileMessageWasBeingSent = 'Mesaj gönderilirken bir hata oluştu.';
Infini.Base.LocDef.MessageWasSuccessfullySent = 'Mesaj başarıyla gönderildi.';

Infini.Base.LocDef.PleaseEnterNecessaryInfo = 'Lütfen \'{0}\' bilgisini giriniz.';
Infini.Base.LocDef.PleaseSelectAnOption = 'Lütfen bir \'{0}\' seçiniz.';
Infini.Base.LocDef.FieldCanNotBeEmpty = '\'{0}\' alanı boş bırakılamaz.';

Infini.Base.LocDef.MoveUp = 'Yukarı Taşı';
Infini.Base.LocDef.MoveDown = 'Aşağı Taşı';


Infini.Base.LocDef.Data = 'Veri';
Infini.Base.LocDef.OldData = 'Eski Veri';
Infini.Base.LocDef.NewData = 'Yeni Veri';
Infini.Base.LocDef.DataType = 'Veri Tipi';
Infini.Base.LocDef.SimilarData = 'Benzer Veriler';
Infini.Base.LocDef.Quantity = 'Miktar';
Infini.Base.LocDef.Quantity2 = 'Adet';
Infini.Base.LocDef.OriginalQuantity = 'Orijinal Miktar';
Infini.Base.LocDef.TotalQuantity = 'Toplam Miktar';
Infini.Base.LocDef.Qty = 'Kutu';
Infini.Base.LocDef.Units = 'Kutu';
Infini.Base.LocDef.Units_Upper = 'KUTU';
Infini.Base.LocDef.TotalUnits = 'Toplam Kutu';
Infini.Base.LocDef.Amount = String.format('Tutar ({0})', Infini.Base.LocDef.MainCurrencyCode);
Infini.Base.LocDef.TotalAmount = 'Toplam TL';
Infini.Base.LocDef.InvoiceNo = 'Fatura No';
Infini.Base.LocDef.InvoiceDate = 'Fatura Tarihi';
Infini.Base.LocDef.DeliveryNoteNo = 'İrsaliye No';
Infini.Base.LocDef.Client = 'Müşteri';
Infini.Base.LocDef.DocNo = 'Doküman No';
Infini.Base.LocDef.DocType = 'Doküman Tipi';
Infini.Base.LocDef.DocDate = 'Doküman Tarihi';
Infini.Base.LocDef.DocDate2 = 'Evrak Tarihi';
Infini.Base.LocDef.CalcDate = 'Hesaplanma Tarihi';
Infini.Base.LocDef.CalcMethod = 'Hesaplama Yöntemi';
Infini.Base.LocDef.Scale = 'Barem';
Infini.Base.LocDef.Scales = 'Baremler';
Infini.Base.LocDef.Weight = 'Ağırlık %';
Infini.Base.LocDef.DiscountPerc = 'İndirim %';
Infini.Base.LocDef.DiscountPerc2 = 'İndirim2 %';
Infini.Base.LocDef.PONo = 'SAS No';

Infini.Base.LocDef.Sales = 'Satış';
Infini.Base.LocDef.MatrixCode = 'Karekod';
Infini.Base.LocDef.SerialNo = 'Seri No';
Infini.Base.LocDef.PartyNo = 'Parti No';

Infini.Base.LocDef.Acceptance = 'Kabul';
Infini.Base.LocDef.Issue = 'Çıkış';


Infini.Core.LocDef.Settings = 'INFINI Web Masaüstü Ayarları';

Infini.Core.LocDef.IssueReporter = 'Sorun Bildirim Aracı';
Infini.Core.LocDef.ShowDesktop = 'Masaüstünü Göster';
Infini.Base.LocDef.JsonEditor = 'JSON Düzenleyici';
Infini.Base.LocDef.FavoriteReports = 'Favori Raporlar';


Infini.DevSupport.LocDef.Functions = 'Destek İşlemleri';
Infini.DevSupport.LocDef.SystemGroup = 'Sistem';
Infini.DevSupport.LocDef.ClearCache = 'Önbelleği Temizle';
Infini.DevSupport.LocDef.ClearCacheDescription = 'Sunucunun önbellekte tuttuğu temel veri listelerini (ürün fiyatları, kadrolar, organizasyon vb.) temizler; bu listeler bir sonraki kullanımda veritabanından yeniden yüklenir.';
Infini.DevSupport.LocDef.ConfirmClearCache = 'Sunucu önbelleği temizlenecek. Devam etmek istiyor musunuz?';
Infini.DevSupport.LocDef.CacheCleared = 'Önbellek temizlendi.';

Infini.Base.LocDef.MessageId = 'Mesaj No';
Infini.Base.LocDef.Latitude = 'Enlem';
Infini.Base.LocDef.Longitude = 'Boylam';
Infini.Base.LocDef.CurrentLocation = 'Güncel Konum';
Infini.Base.LocDef.Location = 'Konum';
Infini.Base.LocDef.KeepLocation = 'Konumu Koru';
Infini.Base.LocDef.UpdatedLocation = 'Konumu Güncelle';
Infini.Base.LocDef.QueriedInstitution = 'Aranan Kurum';
Infini.Base.LocDef.SelectedLocation = 'Seçili Yer';
Infini.Base.LocDef.LatitudeLongitude = 'Enlem, Boylam';

Infini.Base.LocDef.MarkingRecords = 'Kayıt İşaretleme';
Infini.Base.LocDef.SelectedRecordIsAlreadyMarkedAsRead = 'Seçili kayıt \'Okundu\' olarak işaretli.';
Infini.Base.LocDef.ConfirmMarkAsRead = 'Seçili kaydı \'Okundu\' olarak işaretlemek istediğinize emin misiniz?';

Infini.Base.LocDef.Brand = 'Marka';
Infini.Base.LocDef.Model = 'Model';
Infini.Base.LocDef.MissingInformation = 'Eksik bilgiler';
Infini.Base.LocDef.RecordCannotBeSavedWithoutCompletingTheFollowingInfo = 'Aşağıdakiler girilmeden kayıt kaydedilemez';

Infini.Base.LocDef.ConfirmImageDeletion = 'Resmi silmek istediğinizden emin misiniz?';

Infini.Base.LocDef.Question = 'Soru';
Infini.Base.LocDef.Questions = 'Sorular';
Infini.Base.LocDef.Question_upper = 'SORU';
Infini.Base.LocDef.Answer_upper = 'CEVAP';
Infini.Base.LocDef.AnswerChoices = 'CEVAP ŞIKLARI';
Infini.Base.LocDef.QuestionCode = 'Soru Kodu';
Infini.Base.LocDef.QuestionType = 'Soru Tipi';
Infini.Base.LocDef.Correct = 'Doğru';
Infini.Base.LocDef.QuestionCategory = 'Soru Kategorisi';
Infini.Base.LocDef.HasPicture = 'Resimli';
Infini.Base.LocDef.Image = 'Resim';
Infini.Base.LocDef.Images = 'Resimler';
Infini.Base.LocDef.Evaluation = 'Değerlendirme';
Infini.Base.LocDef.Evaluation_upper = 'DEĞERLENDİRME';
Infini.Base.LocDef.Review = 'Değerlendirme';
Infini.Base.LocDef.Score = 'Puan';
Infini.Base.LocDef.TotScore = 'Toplam Puan';
Infini.Base.LocDef.QCount = 'Soru Sayısı';
Infini.Base.LocDef.TotalQCount = 'Toplam Soru Sayısı';
Infini.Base.LocDef.EvaluatedQ = 'Değerlendirilen Soru';
Infini.Base.LocDef.CategoryQuestions = 'Kategori Soruları';

Infini.Base.LocDef.AnswerIsBeingSaved = 'Cevap kaydediliyor...';
Infini.Base.LocDef.ErrorWhileAnswerIsBeingSaved = 'Cevap kaydedilirken bir hata oluştu.';
Infini.Base.LocDef.AnswerIsSuccessfullySaved = 'Cevap başarıyla kaydedildi.';

Infini.Base.LocDef.ParticipantList = 'Katılımcı Listesi';
Infini.Base.LocDef.ParticipantCount = 'Katılımcı Sayısı';
Infini.Base.LocDef.PleaseEnterCancelReason = 'Lütfen iptal nedenini giriniz';

Infini.Base.LocDef.MainDepartment = 'Ana Departman';
Infini.Base.LocDef.SubDepartment = 'Alt Departman';

Infini.Base.LocDef.Application = 'Uygulama';
Infini.Base.LocDef.Mobile = 'Mobile';
Infini.Base.LocDef.CallCenter = 'Çağrı Merkezi';

Infini.Base.LocDef.CardCount = 'Kişi Sayısı';

Infini.Base.LocDef.Changes = 'Değişiklikler';

Infini.Base.LocDef.Positive = 'Olumlu';
Infini.Base.LocDef.Neutral = 'Nötr';
Infini.Base.LocDef.Negative = 'Olumsuz';

Infini.Base.LocDef.PleaseSelectTheOperationYouWantToMake = 'Lütfen yapmak istediğiniz işlemi seçin.';
Infini.Base.LocDef.EnteringValidDateRange = 'Geçerli bir tarih aralığı girmelisiniz.';
Infini.Base.LocDef.EnterEndDateOfDateRange = 'Tarih aralığının son gününü girmelisiniz.';
Infini.Base.LocDef.StartDateMustBeBiggerThanToday = '\'Başlangıç Tarihi\' bugünden büyük olmalıdır.';

Infini.Base.LocDef.CannotSaveOthersRecord = 'Bu kayıt size ait olmadığından kaydetme yetkiniz yoktur.';
Infini.Base.LocDef.CanSelectNextOperationFromBelow = 'Yapmak istediğiniz bir sonraki işlemi aşağıdan seçebilirsiniz.';

Infini.Base.LocDef.Parent = 'Üstü';

Infini.Base.LocDef.ProcessSelected = 'Seçilenleri İşle';
Infini.Base.LocDef.DeleteSelected = 'Seçilenleri Sil';


Infini.Base.LocDef.PackageType = 'Ürün Tipi';
Infini.Base.LocDef.PackageType_RX = 'İlaç';
Infini.Base.LocDef.PackageType_OTC = 'İlaç Dışı';
Infini.Base.LocDef.PackageType_PromotionalMaterial = 'Promosyon';
Ext.ns('Infini.Authentication');

Infini.Base.Helper = function() {

  // Constants
  var layoutConfigs = {
    form: {
      layout: 'form',
      border: false,
      labelAlign: 'right'
    }
  };

  var chartConfigs = {
    legend: {
      display: 'right',
      padding: 4,
      font: {
        family: 'Tahoma',
        size: 9
      }
    }
  };

  var helpContent = {
  };

  var holidays = new Ext.util.MixedCollection(false, function(o) { return o.year; });
  var userAgent = UAParser(navigator.userAgent);

  return {
    constUnknownId: -1,
    constUndefined: '-',
    constStatusActive: 'A',
    constStatusInactive: 'I',
    constStatusUnposted: 'U',
    constStatusPosted: 'P',
    constStatusCancelled: 'X',
    constStatusComplete: 'C',
    constStatusAccepted: 'O',
    constBlankCriteriaId: -200,
    constNonblankCriteriaId: -300,
    baseHelpUrl: 'http://help.infini.idesse.com/index.html?',
    baseHelpVideoUrl: 'http://help.infini.idesse.com/',
    constUISettingNamePrefix: 'uiSetting_',
    logoutUrl: '/Account/Logout',
    loginUrl: '/Account/Login',
    crmHomeUrl: '/Home/Index',
    scmHomeUrl: '/Scm/Index',
    arptUrl: '/lens',
    crmAppCode: 'crm',
    scmAppCode: 'scm',
    favoriteReportsKey: 'FAVORITE_REPORTS',
    downloadCompleteToken: 'downloadCompleteToken',

    getHomeUrl: function() {
      if (document.URL.toLowerCase().indexOf('scm') > -1)
        return '/Scm/Index';
      else
        return '/Home/Index';
    },

    showLoginDialog: function(isForTimeout) {
      if (this.isLoginDlgVisible === true)
        return;

      var dlg = new Infini.Authentication.LoginDialog({
        isForTimeout: isForTimeout
      });
      this.isLoginDlgVisible = true;
      dlg.show(function() {
        this.isLoginDlgVisible = false;
      }, this);
    },

    // For a window both apps open under the same id. CRM: the config as given (a floating window that keeps its position and size).
    // SCM shows one window at a time filling the workspace, so there the window opens maximized and neither restores nor saves its
    // window state (position, size, maximized): that state is shared with CRM and would otherwise float it at its CRM place and size.
    // The grids inside keep their own (shared) state.
    applyAppWindowMode: function(config) {
      if (InfiniApp.getAppCode() !== this.scmAppCode)
        return config;
      var ignoreWindowState = function() {
        return false;
      };
      return Ext.apply(config, {
        maximized: true,
        listeners: Ext.apply(config.listeners || {}, {
          beforestaterestore: ignoreWindowState,
          beforestatesave: ignoreWindowState
        })
      });
    },

    logout: function() {
      var logoutUrl = this.logoutUrl;
      if (InfiniApp.getAppCode() === this.scmAppCode)
        logoutUrl += '/Scm';
      if (typeof appInsights !== 'undefined')
        appInsights.clearAuthenticatedUserContext();
      document.location = logoutUrl;
    },

    showResetPasswordWithCodeDialog: function(resetPwdCode) {
      if (this.isResetPasswordWithCodeDlgVisible === true)
        return;

      var dlg = new Infini.Authentication.ResetPasswordWithCodeDialog({
        resetPwdCode: resetPwdCode
      });
      this.isResetPasswordWithCodeDlgVisible = true;
      dlg.show(function() {
        this.isResetPasswordWithCodeDlgVisible = false;
      }, this);
    },

    getBrowserInfo: function() {
      var nVer = navigator.appVersion;
      var nAgt = navigator.userAgent;
      var browserName = navigator.appName;
      var fullVersion = '' + parseFloat(navigator.appVersion);
      var majorVersion = parseInt(navigator.appVersion, 10);
      var nameOffset, verOffset, ix;

      // In Opera 15+, the true version is after "OPR/" 
      if ((verOffset = nAgt.indexOf("OPR/")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 4);
      }
      // In older Opera, the true version is after "Opera" or after "Version"
      else if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      // In Chrome, the true version is after "Chrome" 
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      // In Safari, the true version is after "Safari" or after "Version" 
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In Firefox, the true version is after "Firefox" 
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
      }
      // In most other browsers, "name/version" is at the end of userAgent 
      else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
        (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix);
      if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix);

      majorVersion = parseInt('' + fullVersion, 10);
      if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }

      //console.log('Browser name = ' + browserName);
      //console.log('Full version = ' + fullVersion);
      //console.log('Major version = ' + majorVersion);
      //console.log('navigator.appName = ' + navigator.appName);
      //console.log('navigator.userAgent = ' + navigator.userAgent);

      return {
        browserName: browserName,
        fullVersion: parseFloat(fullVersion),
        majorVersion: parseInt(majorVersion)
      };
    },

    isBrowserVersionSupported: function() {
      var browserInfo = Infini.Base.Helper.getBrowserInfo();

      var result = true;
      if (browserInfo.browserName === 'Firefox') {
        if (browserInfo.majorVersion < 20)
          result = false;
      } else if (browserInfo.browserName === 'Chrome') {
        if (browserInfo.majorVersion < 30)
          result = false;
      } else if (browserInfo.browserName === 'Internet Explorer') {
        if (browserInfo.majorVersion < 9)
          result = false;
      }

      return result;
    },

    isDeviceIpad: function() {
      // Check for iOS version < 13
      var isIPad = userAgent && userAgent.device && (userAgent.device.vendor === 'Apple' && userAgent.device.model === 'iPad');

      if (!isIPad) {
        // Check for iOS version >= 13
        isIPad = /iPad/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      }

      return isIPad;
    },

    decodeHTMLEntities: function(text) {
      var textArea = document.createElement('textarea');
      textArea.innerHTML = text;
      return textArea.value;
    },

    encodeHTMLEntities: function(text) {
      var textArea = document.createElement('textarea');
      textArea.innerText = text;
      return textArea.innerHTML;
    },

    getCookieStateProvider: function() {
      if (!this.cookieStateProvider) {
        this.cookieStateProvider = new Ext.state.CookieProvider({
          expires: new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 30)) //30 days
        });
      }

      return this.cookieStateProvider;
    },

    getCurrCultureName: function(defCulture = 'tr-TR') {
      return this.getCookieStateProvider().get('language', defCulture);
    },

    getNewColumnConfigCollection: function() {
      return new Ext.util.MixedCollection(false, function(o) { return o.dataIndex; });
    },

    getNewActionConfigCollection: function() {
      return new Ext.util.MixedCollection(false, function(o) { return o.itemId; });
    },

    addHelpContent: function(content) {
      Ext.apply(helpContent, content);
    },

    getHelpContent: function(winId) {
      return helpContent[winId];
    },

    getPlaceHolderFieldCfg: function() {
      return {
        xtype: 'displayfield',
        style: 'height: 22px;',
        //hidden: true,
        disabled: true,
        handleManually: true
      };
    },

    getNumberFormat: function(numOfDigit, padEmptyDigitsWithZero) {
      numOfDigit = numOfDigit || 0;
      if (padEmptyDigitsWithZero === undefined)
        padEmptyDigitsWithZero = true;
      var formatStr = String.format('0{0}000', Infini.Base.LocDef.DecimalGroupingSymbol);

      if (numOfDigit > 0) {
        var numOfDigitStr = '';
        for (var i = 0; i < numOfDigit; i++)
          numOfDigitStr += padEmptyDigitsWithZero ? '0' : '';

        formatStr += Infini.Base.LocDef.DecimalSeparator + numOfDigitStr;
      }

      if (Infini.Base.LocDef.DecimalSeparator === ',')
        formatStr += '/i';

      return formatStr;
    },

    formatNumber: function(number, numOfDigit, padEmptyDigitsWithZero) {
      return Ext.util.Format.number(number, this.getNumberFormat(numOfDigit, padEmptyDigitsWithZero));
    },

    generateRandomInteger: function(min, max, prevValues) {
      var randInt = Math.floor(Math.random() * (max - min + 1)) + min;
      if (prevValues && prevValues.indexOf(randInt) > -1)
        return generateRandomInteger(min, max, prevValues); // jshint ignore:line
      else {
        prevValues.push(randInt);
        return randInt;
      }
    },

    refreshFocus: function(uiElement) {
      // Try to change focus in order to post unsaved classic question answer
      var focusedComps = uiElement.findBy(function(comp, container) {
        return comp.hasFocus;
      }, uiElement);
      if (focusedComps.length > 0) {
        focusedComps[0].onBlur();
        focusedComps[0].onFocus();
      }
    },

    showPopup: function(url, isCentered, name, featuresConfig) {
      featuresConfig = featuresConfig || {};
      var defaultConfig = {
        location: 'no',
        menubar: 'no',
        toolbar: 'no',
        status: 'no',
        directories: 'no',
        width: 700,
        height: 500
      };
      Ext.applyIf(featuresConfig, defaultConfig);
      if (isCentered) {
        var screenWidth = Ext.isIE ? screen.width : screen.availWidth;
        featuresConfig.left = (screenWidth - featuresConfig.width) / 2;
        var screenHeight = Ext.isIE ? screen.height : screen.availHeight;
        featuresConfig.top = (screenHeight - featuresConfig.height) / 2;
      }

      var featuresStr = ''; //"location=no,menubar=no,toolbar=no,status=no,directories=no";
      for (var prop in featuresConfig) {
        if (featuresConfig.hasOwnProperty(prop))
          featuresStr += String.format('{0}={1},', prop, featuresConfig[prop]);
      }

      window.open(url, name, featuresStr);
    },

    // Given a word changes its first char to lowercase
    unCapitalize: function(word) {
      return word.charAt(0).toLowerCase().concat(word.substr(1, word.length - 1));
    },

    trimSpace: function(value) {
      return typeof value === 'string' ? value.replace(/\s*$/, '').replace(/^\s*/, "") : value;
    },

    extractAttributeValue: function(attributeName, searchText) {
      var pattern = new RegExp(String.format('{0}="([^"]+)"', attributeName), 'i');
      var result = pattern.exec(searchText);
      if (result)
        return result[1];
    },

    valuesEqual: function(firstValue, secondValue) {
      if (firstValue !== null && secondValue !== null &&
        typeof firstValue === "object" && typeof secondValue === "object") {
        return firstValue.valueOf() === secondValue.valueOf();
      } else
        return firstValue === secondValue;
    },

    objToArray: function(obj, full) {
      var result = [];
      Ext.iterate(obj, function(k, v) {
        result.push(full === true ? { name: k, value: v } : v);
      }, this);
      return result;
    },

    getTodayDate: function() {
      var todayDate = new Date();
      return new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate());
    },

    getFirstDayOfCurrentMonth: function() {
      var todayDate = new Date();
      return new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
    },

    findDateDiff: function(startDate, endDate, beforeAfterPrefix, applyFormatting) {
      if (!endDate)
        endDate = Infini.Base.Helper.getTodayDate();

      // Get 1 day corresponding milliseconds
      var dayInMS = 1000 * 60 * 60 * 24;

      // Calculate difference btw the two dates, and convert to days
      var days = Math.abs(Math.floor((endDate.getTime() - startDate.getTime()) / (dayInMS)));
      var result;
      if (applyFormatting !== false) {
        result = String.format('{0}<b>{1}</b>', days, Infini.Base.LocDef.DayShort);
        if (beforeAfterPrefix) {
          if (days !== 0) {
            if (beforeAfterPrefix === 'B')
              result = String.format('{0} <span style="color: red">{1}</span>', result, Infini.Base.LocDef.Before);
            else
              result = String.format('{0} <span style="color: blue">{1}</span>', result, Infini.Base.LocDef.After);
          } else
            result = String.format('<b>{0}</b>', 'Bugün');
        }
      } else {
        result = String.format('{0}{1}', days, Infini.Base.LocDef.DayShort);
        if (beforeAfterPrefix) {
          if (days !== 0)
            result = String.format('{0} {1}', result, beforeAfterPrefix === 'B' ? Infini.Base.LocDef.Before : Infini.Base.LocDef.After);
          else
            result = String.format('{0}', 'Bugün');
        }
      }
      return result;
    },

    getTimeDifference: function(earlierDate, laterDate, outputType) {
      var result = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };

      if (!laterDate || !earlierDate)
        return result;

      var difference = laterDate.getTime() - earlierDate.getTime();

      if (!outputType || outputType === 'full') {
        result.days = Math.floor(difference / 1000 / 60 / 60 / 24);
        difference -= result.days * 1000 * 60 * 60 * 24;

        result.hours = Math.floor(difference / 1000 / 60 / 60);
        difference -= result.hours * 1000 * 60 * 60;

        result.minutes = Math.floor(difference / 1000 / 60);
        difference -= result.minutes * 1000 * 60;

        result.seconds = Math.floor(difference / 1000);
      } else if (outputType === 'days') {
        result.days = Math.floor(difference / 1000 / 60 / 60 / 24);
      } else if (outputType === 'minutes') {
        result.minutes = Math.floor(difference / 1000 / 60);
      }

      return result;
    },

    getDurationFromSeconds: function(seconds, outputType) {
      var result = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };

      var difference = seconds;

      if (!outputType || outputType === 'full') {
        result.days = Math.floor(difference / 60 / 60 / 24);
        difference -= result.days * 60 * 60 * 24;

        result.hours = Math.floor(difference / 60 / 60);
        difference -= result.hours * 60 * 60;

        result.minutes = Math.floor(difference / 60);
        difference -= result.minutes * 60;

        result.seconds = difference;
      } else if (outputType === 'minutes') {
        result.minutes = Math.floor(difference / 60);
        difference -= result.minutes * 60;

        result.seconds = difference;
      }

      return result;
    },

    findWorkDay: function(beforeDate, date, doNotUseGivenDate) {
      var result = date || new Date();
      var increment = beforeDate === true ? -1 : 1;
      if (doNotUseGivenDate)
        result = result.add(Date.DAY, increment);
      while (result.getDay() === 0 || result.getDay() === 6)
        result = result.add(Date.DAY, increment);
      return new Date(result.getFullYear(), result.getMonth(), result.getDate());
    },

    getHolidays: function(year) {
      var result = [];
      if (!year)
        return result;

      if (holidays.containsKey(year))
        result = holidays.get(year).holidays;
      else {
        Infini.Base.AjaxHelper.makeRequest('GET', '/CalendarDate/GetHolidaysOfYear/' + year,
          function(options, opSuccess, response) {
            if (opSuccess && response.responseJSON && response.responseJSON.success === true && response.responseJSON.data) {
              var yearData = {
                year: year,
                holidays: response.responseJSON.data
              };
              Ext.each(yearData.holidays, function(item) {
                item.date = Infini.Base.Helper.convertToJSFormatDate(item.date);
              });
              holidays.add(yearData);
              result = yearData.holidays;
            }
          }, {
          async: false,
          scope: this,
          waitTitle: Infini.Base.LocDef.WaitTitle,
          waitMsg: Infini.Base.LocDef.HolidaysAreBeingRetrieved,
          successMessage: '',
          failureMessage: Infini.Base.LocDef.RecordCanNotBeLoaded
        }
        );
      }

      return result;
    },

    mergeRenderers: function(colCfg, newRendererFn) {
      if (typeof newRendererFn != "function")
        return this;

      if (colCfg.renderer) {
        var method = colCfg.renderer;
        colCfg.renderer = function() {
          var retVal = method.apply(this, arguments);
          arguments[0] = retVal; // jshint ignore:line
          return newRendererFn.apply(this, arguments);
        };
      } else {
        colCfg.renderer = function() {
          return newRendererFn.apply(this, arguments);
        };
      }
    },

    prevRowComparerRenderer: function(value, metaData, record, rowIndex, colIndex, store) {
      if (rowIndex > 0) {
        var prevRowVal = store.data.items[rowIndex - 1].data[this.name];
        if (!Infini.Base.Helper.valuesEqual(value, prevRowVal))
          metaData.css = 'red-font';
      }
      return value;
    },

    consoleOut: function(fnType, args) {
      if (!Ext.isGecko || (typeof console === 'undefined'))
        return;

      switch (fnType) {
        case 'log':
          console.log(args); //Ext.log(args);
          break;
        case 'info':
          console.info(args);
          break;
        case 'dump':
          console.dump(args); //Ext.dump(args);
          break;
      }
    },

    getTimeFormat: function() {
      return 'H:i';
    },

    getDateFormat: function() {
      return 'd/m/Y'; 
    },

    getDateFormat2: function() {
      return 'j/n/Y'; 
    },

    getFullDateFormat: function() {
      return 'Y-m-d\\TH:i:s'; 
    },

    getCalendarDateFormat: function() {
      return 'm/d/Y';   
    },

    getUrlDateFormat: function() {
      return 'd-m-Y';   
    },

    getKeyDateFormat: function() {
      return 'Ymd';   
    },

    getFormSerializationFormat: function() {
      return 'Y-m-d'; 
    },

    getDateTimeFormat: function() {
      return 'd/m/Y H:i'; 
    },

    getIso8601DateTimeFormat: function() {
      return 'c'; 
    },

    getMinServerDateStr: function() {
      if (!Infini.Base.Helper.minServerDateStr)
        Infini.Base.Helper.minServerDateStr = Ext.util.Format.date(new Date(1, 0, 1), Infini.Base.Helper.getDateFormat());
      return Infini.Base.Helper.minServerDateStr;
    },

    convertToJSFormatDateStr: function(dateStrInFullDateFormat) {
      return Date.parseDate(dateStrInFullDateFormat,
        Infini.Base.Helper.getFullDateFormat()).format(Infini.Base.Helper.getCalendarDateFormat());
    },

    convertToJSFormatDate: function(dateStrInFullDateFormat) {
      return Date.parseDate(dateStrInFullDateFormat, Infini.Base.Helper.getFullDateFormat());
    },

    timerStartTime: undefined,

    startTimer: function() {
      this.timerStartTime = new Date().getTime();
    },

    stopTimer: function(message) {
      var timerEndTime = new Date().getTime();

      Infini.Base.Helper.consoleOut('log', [message || 'stopTimer', timerEndTime - this.timerStartTime]);
    },

    getRecordOnGridMouseOver: function(grid, e) {
      var t = e.getTarget();
      var v = grid.getView();
      var rowIdx = v.findRowIndex(t);
      return grid.getStore().getAt(rowIdx);
    },

    getLayoutConfig: function(configName, defaultConfig) {
      return Ext.apply({}, layoutConfigs[configName], (defaultConfig || {}));
    },

    getChartConfig: function(configName, extraConfig) {
      return Ext.applyIf(extraConfig || {}, chartConfigs[configName]);
    },

    getEnumStoreConfig: function(additionalConfig, defaultConfig) {
      var baseConfig = {
        root: 'data',
        idProperty: 'Key',
        fields: [{
          name: 'Key'
        }, {
          name: 'Value'
        }],
        sortInfo: {
          field: 'Key',
          direction: "ASC"
        }
      };
      Ext.apply(baseConfig, defaultConfig);
      Ext.applyIf(baseConfig, additionalConfig);

      return baseConfig;
    },

    getEntityFormAuditConfig: function() {
      return {
        items: [
          {
            xtype: 'textfield',
            fieldLabel: Infini.Base.LocDef.CreatedBy,
            name: 'CreatedBy',
            disabled: true,
            readOnly: true, // not to enable them
            submitValue: false
          }, {
            xtype: 'xdatetime',
            fieldLabel: Infini.Base.LocDef.CreatedOn,
            name: 'CreatedOn',
            disabled: true,
            readOnly: true, // not to enable them
            submitValue: false
          }, {
            xtype: 'textfield',
            fieldLabel: Infini.Base.LocDef.ModifiedBy,
            name: 'ModifiedBy',
            disabled: true,
            readOnly: true, // not to enable them
            submitValue: false
          }, {
            xtype: 'xdatetime',
            fieldLabel: Infini.Base.LocDef.ModifiedOn,
            name: 'ModifiedOn',
            disabled: true,
            readOnly: true, // not to enable them
            submitValue: false
          }
        ]
      };
    },

    getProcessedResponseError: function(responseObj) {
      var message = '';
      if (!responseObj) {
        message = Infini.Base.LocDef.AnErrorOccurredOnTheServerSide;
      } else if (responseObj.responseJSON) {
        message = responseObj.options.failureMessage || '';
        if (responseObj.responseJSON.errorMsg || responseObj.responseJSON.errors) {
          message += (message ? '<br/><br/><ul class="errorList">' : '');
          if (responseObj.responseJSON.errorMsg)
            message += '<li>' + responseObj.responseJSON.errorMsg + '</li>';
          if (responseObj.responseJSON.errors) {
            Ext.each(responseObj.responseJSON.errors, function(item) {
              var caption = item.caption || item.id;
              if (caption)
                message += '<li><span style="font-weight: bold">' + caption + '</span>: ' + item.msg + '</li>';
              else
                message += '<li>' + item.msg + '</li>';
            }, this);
          }
          message += '</ul>';
        }
      } else {
        message = (responseObj.options && responseObj.options.failureMessage) || '';

        var e = responseObj.fullStatus ? responseObj.fullStatus.error : undefined;
        if (e) {
          var fullStatusMessage;
          if (e.number)
            fullStatusMessage += '<b>No:</b> ' + e.number + '<br/><br/>';
          if (e.name)
            fullStatusMessage += '<b>' + Infini.Base.LocDef.Name + ':</b> ' + e.name + '<br/><br/>';
          if (e.message)
            fullStatusMessage += '<b>' + Infini.Base.LocDef.Message + ':</b> ' + e.message + '<br/><br/>';
          if (e.description)
            fullStatusMessage += '<b>' + Infini.Base.LocDef.Description + ':</b> ' + e.description;
          if (fullStatusMessage)
            message += (message ? '<br/><br/>' : '') + fullStatusMessage;
        }

        if (responseObj.responseText) {
          var htmlResponse = Ext.ux.util.extractTagContent('title', responseObj.responseText);
          if (!htmlResponse || !(htmlResponse.length > 1)) // jshint ignore:line
            htmlResponse = Ext.ux.util.extractTagContent('i', responseObj.responseText);
          if (htmlResponse && htmlResponse.length > 1)
            message += (message ? '<br/><br/>' : '') + htmlResponse[1];
        }
      }

      return message;
    },

    compressFile: function(fileInput, callbackFn) {
      var requestFileSystem = window.webkitRequestFileSystem || window.mozRequestFileSystem || window.requestFileSystem;

      function createTempZipFile(callback) {
        var tmpFilename = "tmp.zip";
        requestFileSystem(TEMPORARY, 4 * 1024 * 1024 * 1024, function(filesystem) {
          function create() {
            filesystem.root.getFile(tmpFilename, {
              create: true
            }, function(zipFile) {
              callback(zipFile);
            });
          }

          filesystem.root.getFile(tmpFilename, null, function(entry) {
            entry.remove(create, create);
          }, create);
        });
      }

      var model = (function() {
        var zipFileEntry, zipWriter, writer, creationMethod;

        return {
          setCreationMethod: function(method) {
            creationMethod = method;
          },
          addFiles: function addFiles(files, oninit, onadd, onprogress, onend) {
            var addIndex = 0;

            function nextFile() {
              var file = files[addIndex];
              if (Ext.isFunction(onadd))
                onadd(file);
              zipWriter.add(file.name, new zip.BlobReader(file), function() {
                addIndex++;
                if (addIndex < files.length)
                  nextFile();
                else {
                  if (Ext.isFunction(onend))
                    onend();
                }
              }, onprogress);
            }

            function createZipWriter() {
              zip.createWriter(writer, function(writer) {
                zipWriter = writer;
                if (Ext.isFunction(oninit))
                  oninit();
                nextFile();
              }, onerror);
            }

            if (zipWriter)
              nextFile();
            else if (creationMethod == 'Blob') {
              writer = new zip.BlobWriter();
              createZipWriter();
            } else {
              createTempZipFile(function(fileEntry) {
                zipFileEntry = fileEntry;
                writer = new zip.FileWriter(zipFileEntry);
                createZipWriter();
              });
            }
          },
          getBlob: function(callback) {
            zipWriter.close(callback);
          }
        };
      })();

      model.setCreationMethod('Blob');
      //model.setCreationMethod(typeof requestFileSystem == "undefined" ? 'Blob' : 'File');

      var waitBox;
      model.addFiles(fileInput.dom.files, function() {
        waitBox = Ext.MessageBox.wait(Infini.Base.LocDef.FileIsBeingCompressed, Ext.form.BasicForm.prototype.waitTitle);

      }, undefined, undefined, function() {
        waitBox.hide();
        if (callbackFn) {
          model.getBlob(function(blob) {
            callbackFn(blob);
          });
        }
      });
    },

    createDummyForm: function() {
      if (!Ext.fly('frmDummy')) {
        var frm = document.createElement('form');
        frm.id = 'frmDummy';
        frm.className = 'x-hidden';

        var hiddenInput = document.createElement('input');
        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('id', Infini.Base.Helper.downloadCompleteToken);
        hiddenInput.setAttribute('name', Infini.Base.Helper.downloadCompleteToken);
        frm.appendChild(hiddenInput);

        document.body.appendChild(frm);
      }
    },

    getTempForm: function() {
      let tempForm = Ext.get('tempForm-10');
      if (tempForm)
        document.body.removeChild(tempForm.dom);

      tempForm = document.createElement('form');
      tempForm.id = 'tempForm-10';
      tempForm.className = 'x-hidden';
      document.body.appendChild(tempForm);

      return tempForm;
    },

    invokeFileUpload: function(permittedExtensions, isMultiple, url, params) {
      const fileButton = document.createElement("button");
      fileButton.onclick = (function() {
        let fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.id = Ext.id();
        fileInput.name = fileInput.id;
        fileInput.accept = permittedExtensions;
        fileInput.multiple = isMultiple;
        fileInput.onchange = _this => {
          Infini.Base.Helper.uploadFile(Ext.get(fileInput), url, params, {
            waitMessage: Infini.Base.LocDef.RecordIsBeingSaved,
            scope: this
          }, function(responseObj) {
            if (responseObj && responseObj.success === true) {
              if (params.callback) {
                params.callback.call(params.scope);
              }
            }
          });
        };
        fileInput.click();
      })();
    },

    uploadFile: function(fileInput, url, params, options, callback) {
      if (params.doCompression && Infini.Base.Helper.checkIfFormDataIsSupported(false) && fileInput.dom.files) {
        Infini.Base.Helper.compressFile(fileInput, function(blob) {
          var compressedFile = new FormData();

          params = params || {};
          for (var prop in params) {
            if (params.hasOwnProperty(prop))
              compressedFile.append(prop, params[prop]);
          }
          compressedFile.append(returnResult, Ext.isIE ? false : undefined);
          compressedFile.append('Slice', blob);

          options = Ext.apply({
            isUpload: true,
            method: 'POST',
            useJsonHook: false,

            params: params
          }, options);

          options.waitBox = Ext.MessageBox.wait(options.waitMessage || Infini.Base.LocDef.FileIsBeingUploaded, Ext.form.BasicForm.prototype.waitTitle);
          delete options.waitMessage;

          Infini.Base.AjaxHelper.makeRequest('POST', url,
            function(options, opSuccess, response) {
              options.waitBox.hide();

              if (options.params.returnResult === false) {
                if (callback)
                  callback.call(options.scope, responseObj);
              } else {
                var responseObj = Ext.ux.util.getResponseJsonFromResponseText(response);
                if (responseObj && responseObj.success === false)
                  Infini.Base.Helper.showMessageBox('error', {
                    header: String.format('{0} {1}', Infini.Base.LocDef.ErrorWhileFileWasBeingUploaded, responseObj.errorMsg),
                    items: responseObj.errors
                  });

                if (callback)
                  callback.call(options.scope, responseObj);
              }
            }, options);
        });
      } else {
        var tempForm = Infini.Base.Helper.getTempForm();
        fileInput.appendTo(tempForm);
        params = params || {};
        params.returnResult = Ext.isIE ? false : undefined;

        options = Ext.apply({
          isUpload: true,
          form: tempForm,
          method: 'POST',
          useJsonHook: false,

          params: params
        }, options);

        options.waitBox = Ext.MessageBox.wait(options.waitMessage || Infini.Base.LocDef.FileIsBeingUploaded, Ext.form.BasicForm.prototype.waitTitle);
        delete options.waitMessage;

        Infini.Base.AjaxHelper.makeRequest('POST', url,
          function(options, opSuccess, response) {
            options.waitBox.hide();

            document.body.removeChild(tempForm);

            if (options.params.returnResult === false) {
              if (callback)
                callback.call(options.scope, responseObj);
            } else {
              var responseObj = Ext.ux.util.getResponseJsonFromResponseText(response);
              if (responseObj && responseObj.success === false)
                Infini.Base.Helper.showMessageBox('error', {
                  header: String.format('{0} {1}', Infini.Base.LocDef.ErrorWhileFileWasBeingUploaded, responseObj.errorMsg),
                  items: responseObj.errors
                });
              if (callback)
                callback.call(options.scope, responseObj);
            }
          }, options);
      }
    },

    checkIfFormDataIsSupported: function(showMessage, fallbackFn, scope) {
      if (!Ext.isDefined(window.FormData)) {
        var message = Infini.Base.LocDef.BrowserIncompatibility_FormData;
        if (fallbackFn) {
          if (showMessage) {
            message += '<br/><br/>' + Infini.Base.LocDef.BrowserIncompatibility_FormData_Resolution;
            Ext.Msg.confirm(Infini.Base.LocDef.BrowserIncompatibility, message, function confirmCallback(response) {
              if (response === 'yes')
                fallbackFn.call(scope);
            }, this);
          } else
            fallbackFn.call(scope);
        } else {
          if (showMessage)
            Ext.Msg.alert(Infini.Base.LocDef.BrowserIncompatibility, message);
        }
        return false;
      } else
        return true;
    },

    uploadChunkedFile: function(fileInput, options, checkIfSupported) {
      var internalFn = function(file, fileName, fileMimeType) {
        var fileInfo = {
          chunkSize: 524288 // 512 KB
        };
        fileInfo.chunkCount = Math.ceil(file.size / fileInfo.chunkSize);

        startUpload = function(chunkedCatalogId) {
          Ext.MessageBox.show({
            title: Ext.form.BasicForm.prototype.waitTitle,
            msg: Infini.Base.LocDef.FileIsBeingUploaded,
            progressText: Infini.Base.LocDef.ChunkedFileIsBeingUploaded,
            width: 300,
            progress: true,
            closable: false
          });

          var start = 0,
            end = Math.min(fileInfo.chunkSize, file.size),
            retryCount = 0,
            currentChunkNo = 1,
            result = false;

          uploadNextChunk = function() {
            var fileChunk = new FormData();
            fileChunk.append('chunkedCatalogId', chunkedCatalogId);
            fileChunk.append('currentChunkNo', currentChunkNo);

            if (file.slice) {
              fileChunk.append('Slice', file.slice(start, end));
            } else if (file.webkitSlice) {
              fileChunk.append('Slice', file.webkitSlice(start, end));
            } else if (file.mozSlice) {
              fileChunk.append('Slice', file.mozSlice(start, end));
            } else {
              Ext.MessageBox.hide();

              Infini.Base.Helper.showMessageBox('error', Infini.Base.LocDef.BrowserIncompatibility_FormData2);
              return;
            }

            Infini.Base.AjaxHelper.makeRequest('POST', '/Catalog/UploadCurrentChunk',
              function(reqOptions, opSuccess, response) {
                if (opSuccess && response.responseJSON) {
                  if (response.responseJSON.success === true) {
                    var progress = currentChunkNo / fileInfo.chunkCount;
                    if (progress <= 1)
                      Ext.MessageBox.updateProgress(progress, String.format(Infini.Base.LocDef.PercentComplete, Math.round(progress * 100)));

                    ++currentChunkNo;
                    if (currentChunkNo <= fileInfo.chunkCount) {
                      start = (currentChunkNo - 1) * fileInfo.chunkSize;
                      end = Math.min(currentChunkNo * fileInfo.chunkSize, file.size);
                      retryCount = 0;

                      uploadNextChunk.call(this);
                    } else {
                      Ext.MessageBox.hide();

                      options.catalogCreationCallback.call(options.scope || this, chunkedCatalogId, fileName, fileMimeType);
                    }
                  }
                }
              }, {
              waitMessage: '',
              successMessage: '',
              failureMessage: Infini.Base.LocDef.ErrorWhileChunkedFileWasBeingUploaded,
              params: fileChunk
            }
            );

          };

          uploadNextChunk.call(this);

          return result;
        };

        Infini.Base.AjaxHelper.makeRequest('POST', '/Catalog/CreateChunkedCatalog',
          function(options, opSuccess, response) {
            if (opSuccess && response.responseJSON && response.responseJSON.success === true) {
              startUpload.call(this, response.responseJSON.data.chunkedCatalogId);
            }
          }, {
          async: true,
          scope: this,
          params: {
            fileName: fileName,
            fileSize: file.size,
            chunkCount: fileInfo.chunkCount
          },
          waitMessage: Infini.Base.LocDef.ChunkedFileUploadProcessIsBeingStarted,
          failureMessage: Infini.Base.LocDef.ErrorWhileChunkedFileUploadProcessWasBeingStarted,
          successMessage: ''
        }
        );
      };

      if (!Ext.isFunction(options.catalogCreationCallback))
        throw 'catalogCreationCallback function must be defined.';

      if (checkIfSupported !== false && !Infini.Base.Helper.checkIfFormDataIsSupported())
        return;

      var fileName, fileMimeType;
      if (options.doCompression && fileInput.dom.files && fileInput.dom.files.length > 0) {
        fileName = Ext.ux.util.extractFileName(fileInput.dom.value, true);
        fileName = String.format('{0}.zip', fileName);
        fileMimeType = 'application/x-zip-compressed';

        Infini.Base.Helper.compressFile(fileInput, function(blob) {
          internalFn(blob, fileName, fileMimeType);
        });
      } else {
        var file = fileInput.dom.files[0];
        fileName = Ext.ux.util.extractFileName(fileInput.dom.value, false);
        fileMimeType = fileInput.dom.files[0].type;

        internalFn(file, fileName, fileMimeType);
      }
    },

    showWaitDialog: function(url) {
      Ext.util.Cookies.set(Infini.Base.Helper.downloadCompleteToken, null, new Date("January 1, 1970"));

      var waitBox = Ext.MessageBox.wait(Infini.Base.LocDef.FileIsBeingDownloaded, Ext.form.BasicForm.prototype.waitTitle);
      var tokenInput = document.getElementById(Infini.Base.Helper.downloadCompleteToken);
      var tokenValue = encodeURIComponent(url);
      tokenInput.setAttribute('value', tokenValue);

      var runner = new Ext.util.TaskRunner();
      var task = {
        run: function() {
          var cookieValue = Ext.util.Cookies.get(Infini.Base.Helper.downloadCompleteToken);
          if (cookieValue === url) {
            waitBox.hide();
            Ext.util.Cookies.set(Infini.Base.Helper.downloadCompleteToken, null, new Date("January 1, 1970"));

            runner.stop(task);
          }
        },
        interval: 1000 //1 second
      };
      runner.start(task);

      return waitBox;
    },

    downloadToFile: function(url, params) {
      Infini.Base.Helper.createDummyForm();

      // form-submit downloads follow the 302 to blob storage natively; explicit caller params win
      params = Ext.apply({ allowRedirect: true }, params);

      var waitDlg = Infini.Base.Helper.showWaitDialog(url);

      Infini.Base.AjaxHelper.makeRequest('GET', url,
        function(options, opSuccess, response) {
          var responseObj = Ext.ux.util.getResponseJsonFromResponseText(response);

          if (responseObj) {
            if (responseObj.success === false)
              Infini.Base.Helper.showMessageBox('error', { header: Infini.Base.LocDef.ErrorWhileFileWasBeingDownloaded, items: [responseObj.errorMsg] });
          }
        }, {
        isUpload: true,
        form: Ext.fly('frmDummy'),
        useJsonHook: false,
        params: params,

        scope: this,
        waitMessage: Infini.Base.LocDef.FileIsBeingDownloaded,
        failureMessage: Infini.Base.LocDef.ErrorWhileFileWasBeingDownloaded,
        successMessage: ''
      }
      );
    },

    showPdf: function(mediaId, fileName, fullUrl) {
      if (this.pdfViewer) {
        this.pdfViewer.mediaId = mediaId;
        this.pdfViewer.fileName = fileName;
        this.pdfViewer.fullUrl = fullUrl;
      } else {
        this.pdfViewer = new Infini.System.PdfViewer({
          mediaId: mediaId,
          fileName: fileName,
          fullUrl: fullUrl
        });
      }
      this.pdfViewer.show();
    },

    jsonEncodeStore: function(store, isArray, callback, scope, onlyModified) {
      var json = '';
      var allItems = store.isFiltered() && store.snapshot ? store.snapshot : store.data;

      allItems.each(function(item) {
        if (onlyModified && !item.modified)
          return;

        var record = item.data;
        if (callback)
          record = callback.call(scope || item.data, item.data);
        if (record) {
          if (Ext.isArray(record)) {
            Ext.each(record, function(frec) {
              json += Ext.util.JSON.encode(frec) + ',';
            });
          } else
            json += Ext.util.JSON.encode(record) + ',';
        }
      });
      json = json.substring(0, json.length - 1);
      if (isArray === true)
        json = '[' + json + ']';
      return json;
    },

    jsonEncodeRecords: function(records, isArray, callback, scope) {
      var json = '';
      if (Ext.isArray(records)) {
        Ext.each(records, function(item) {
          var record = item.data;
          if (callback)
            record = callback.call(scope || item.data, item.data);
          json += Ext.util.JSON.encode(record) + ',';
        });
      } else {
        // MixedCollection
        records.each(function(item) {
          var record = item.data;
          if (callback)
            record = callback.call(scope || item.data, item.data);
          json += Ext.util.JSON.encode(record) + ',';
        });
      }
      json = json.substring(0, json.length - 1);
      if (isArray === true)
        json = '[' + json + ']';
      return json;
    },

    jsonEncodeArray: function(array, callback, scope) {
      var json = '';
      Ext.each(array, function(item) {
        if (callback)
          item = callback.call(scope || item, item);
        json += Ext.util.JSON.encode(item) + ',';
      });
      json = json.substring(0, json.length - 1);

      json = '[' + json + ']';
      return json;
    },

    parseXml: function(xmlData) {
      if (typeof DOMParser != "undefined") {
        // Mozilla, Firefox, and related browsers
        return (new DOMParser()).parseFromString(xmlData, "text/xml");
      } else if (typeof ActiveXObject != "undefined") {
        // IE
        var doc = new ActiveXObject("Microsoft.XMLDOM");    // Create an empty document
        doc.loadXML(xmlData);                               // Parse text into it
        return doc;                                         // Return it
      } else {
        // As a last resort, try loading the document from a data: URL
        // This is supposed to work in Safari. Thanks to Manos Batsis and
        // his Sarissa library (sarissa.sourceforge.net) for this technique.
        var url = "data:text/xml;charset=utf-8," + encodeURIComponent(xmlData);
        var request = new XMLHttpRequest();
        request.open("GET", url, false);
        request.send(null);
        return request.responseXML;
      }
    },

    showMessageBox: function(notificationType, message, config) {
      config = config || {};

      var messageStr;
      if (Ext.isObject(message)) {
        if (message.header)
          messageStr = message.header;

        if (message.items instanceof Array) {
          if (!Ext.isEmpty(messageStr))
            messageStr += '<br/><br/>';
          messageStr += '<ul>';
          Ext.each(message.items, function(item) {
            if (Ext.isObject(item)) {
              if (item.msg) {
                var caption = item.caption || item.id;
                if (caption)
                  messageStr += String.format('<li><span style="font-weight: bold">{0}</span>: {1}</li>', caption, item.msg);
                else
                  messageStr += String.format('<li>{0}</li>', item.msg);
              }
            } else if (!Ext.isEmpty(item))
              messageStr += String.format('<li>{0}</li>', item);
          });
          messageStr += '</ul>';
        }
      } else
        messageStr = message;

      var title, icon, buttons;
      switch (notificationType) {
        case 'error':
          title = config.title || Infini.Base.LocDef.Error;
          icon = Ext.MessageBox.ERROR;
          buttons = config.buttons || Ext.Msg.OK;
          break;
        case 'info':
          title = config.title || Infini.Base.LocDef.Information;
          icon = Ext.MessageBox.INFO;
          buttons = config.buttons || Ext.Msg.OK;
          break;
        case 'question':
          title = config.title || Infini.Base.LocDef.Confirmation;
          icon = Ext.MessageBox.QUESTION;
          buttons = config.buttons || Ext.Msg.YESNO;
          break;
        case 'warning':
          title = config.title || Infini.Base.LocDef.Warning;
          icon = Ext.MessageBox.WARNING;
          buttons = config.buttons || Ext.Msg.YESNOCANCEL;
          break;
      }

      return Ext.MessageBox.show({
        msg: messageStr,
        title: title,
        icon: icon,
        buttons: buttons,
        fn: config.callback,
        scope: config.scope,
        appendMsg: config.appendMsg
      });
    },

    showNotification: function(message, notificationType, title, onClick, scope) {
      if (message instanceof Array) {
        var messageList = message;
        message = '';
        Ext.each(messageList, function(item) {
          message += String.format('<p>&nbsp&nbsp{0}</p>', item);
        });
      }

      var iconCls = '';
      switch (notificationType) {
        case 'info':
          title = title || Infini.Base.LocDef.Information;
          iconCls = 'icon-information';
          break;
        case 'wait':
          title = title || Infini.Base.LocDef.ProcessInProgress;
          iconCls = 'icon-waiting';
          break;
        case 'complete':
          title = title || Infini.Base.LocDef.ProcessComplete;
          iconCls = 'icon-done';
          break;
        case 'warning':
          title = title || Infini.Base.LocDef.Warning;
          iconCls = 'icon-warning';
          break;
        case 'alert':
          title = title || Infini.Base.LocDef.Error;
          iconCls = 'icon-alert';
          break;
      }

      if (typeof InfiniApp !== 'undefined') {
        var win = InfiniApp.getDesktop().showNotification({
          html: message,
          title: title,
          iconCls: iconCls
        });
        // optional: a click on the message closes the notification and runs onClick (e.g. opens the page the message points to)
        if (onClick && win && win.body) {
          win.body.setStyle('cursor', 'pointer');
          win.body.on('click', function() {
            if (win.task)
              win.task.cancel();   // the auto-hide must not close it a second time
            win.close();
            onClick.call(scope || this);
          }, this);
        }
      } else {
        Ext.MessageBox.show({
          msg: message,
          title: title,
          buttons: Ext.MessageBox.OK,
          icon: notificationType !== 'alert' ? Ext.MessageBox.INFO : Ext.MessageBox.WARNING
        });
      }
    },

    notifyCompleted: function(message) {
      this.showNotification(message, 'complete', Infini.Base.LocDef.OperationComplete);
    },

    showModule: function(app, moduleName, config) {
      config = config || {};
      config = typeof config == 'object' ? config : { entityId: config };
      app.makeRequest(moduleName, [{
        action: 'createWindow',
        params: config,
        scope: this
      }]);
    },

    
    confirmDelete: function(callbackFn, scope, recordCount, entityDescr) {
      var delConfirmMsg;
      if (recordCount > 1) {
        if (entityDescr)
          delConfirmMsg = String.format(Infini.Base.LocDef.SelectedEntityRecords, recordCount, entityDescr);
        else
          delConfirmMsg = String.format(Infini.Base.LocDef.SelectedRecords, recordCount);
      } else {
        if (entityDescr)
          delConfirmMsg = String.format(Infini.Base.LocDef.SelectedEntityRecord, entityDescr);
        else
          delConfirmMsg = Infini.Base.LocDef.SelectedRecord;
      }
      if (Infini.Base.LocDef.ConfirmDelete[0] === ' ')
        delConfirmMsg = delConfirmMsg + Infini.Base.LocDef.ConfirmDelete;
      else
        delConfirmMsg = Infini.Base.LocDef.ConfirmDelete + delConfirmMsg;
      Ext.Msg.confirm(Infini.Base.LocDef.RecordDeletion, delConfirmMsg, function confirmCallback(response) {
        if (response === 'yes')
          callbackFn.call(scope);
      }, this);
    },

    deleteEntity: function(scope, entityTypeName, entityId, params, callbackFn, deleteActionName, entityDescr) {
      var delConfirmMsg = Infini.Base.LocDef.ConfirmRecordDelete;
      if (entityDescr) {
        delConfirmMsg = String.format(Infini.Base.LocDef.SelectedEntityRecord, entityDescr);
        if (Infini.Base.LocDef.ConfirmDelete[0] === ' ')
          delConfirmMsg = delConfirmMsg + Infini.Base.LocDef.ConfirmDelete;
        else
          delConfirmMsg = Infini.Base.LocDef.ConfirmDelete + delConfirmMsg;
      }
      Ext.Msg.confirm(Infini.Base.LocDef.RecordDeletion, delConfirmMsg, function confirmCallback(response) {
        if (response === 'yes')
          this.deleteEntityDirect(scope, entityTypeName, entityId, params, callbackFn, deleteActionName);
      }, this);
    },

    deleteEntityDirect: function(scope, entityTypeName, entityId, params, callbackFn, deleteActionName) {
      if (!params)
        params = { data: 'dummy' }; // FFBug: FireFox will miss out the Content-Length, if we use POST and do not supply anything
      var url = String.format('/{0}/{1}{2}', entityTypeName, deleteActionName || 'Delete', (entityId ? '/' + entityId : ''));
      Infini.Base.AjaxHelper.makeRequest('POST', url, callbackFn,
        {
          scope: scope,
          params: params,
          waitMessage: Infini.Base.LocDef.RecordIsBeingDeleted,
          failureMessage: Infini.Base.LocDef.RecordCanNotBeDeleted,
          successMessage: Infini.Base.LocDef.RecordIsSuccessfullyDeleted
        }
      );
    },

    showReport: function(reportName, reportParams, reportOptions) {
      Infini.Base.Helper.showModule(InfiniApp, 'genericReportForm', {
        entityId: reportName,
        reportParams: reportParams,
        reportOptions: reportOptions
      });
    },

    exportReport: function(reportName, isId, reportParams) {
      var url;
      if (typeof reportName === "string")
        url = '/Report/Execute/' + reportName + (isId ? '/true' : '/false');
      else
        url = '/Report/Execute/' + reportName.id + (isId ? '/true' : '/false');

      Infini.Base.Helper.exportReportInternal(url, reportParams);
    },

    // syncOnly: true skips the queued path (Infini.ReportExport.start falls back here when the server answers queued: false)
    exportReportInternal: function(url, reportParams, syncOnly) {
      // queued report export (design 2026-10-17), only when the tenant turned it on; otherwise the synchronous iframe download below
      if (syncOnly !== true && typeof InfiniApp !== 'undefined' && InfiniApp.user && InfiniApp.user.ReportExportQueued === true && typeof Infini.ReportExport !== 'undefined') {
        Infini.ReportExport.start(url, reportParams);
        return;
      }

      // isUpload: true --> This will make ajax request use a hidden iframe.
      // isUpload only works as expected if a 'form' config is also provided.
      Infini.Base.Helper.createDummyForm();

      var parameters = reportParams || {};
      if (!parameters._formatType)
        parameters._formatType = 'PDF';
      parameters._export = true;

      var waitDlg = Infini.Base.Helper.showWaitDialog(url);

      Infini.Base.AjaxHelper.makeRequest('POST', url,
        function(options, opSuccess, response) {
          var responseObj = Ext.ux.util.getResponseJsonFromResponseText(response);

          if (responseObj && responseObj.success === false)
            Infini.Base.Helper.showMessageBox('error', { header: Infini.Base.LocDef.AnErrorOccuredWhileReportIsBeingPrepared, items: [responseObj.errorMsg] });
        }, {
        isUpload: true,
        form: Ext.fly('frmDummy'),
        useJsonHook: false,

        timeout: 120000,
        scope: this,
        params: parameters,
        waitMessage: Infini.Base.LocDef.ReportIsBeingPrepared,
        failureMessage: Infini.Base.LocDef.ReportCanNotBeExported,
        successMessage: ''
      }
      );
    },

    keepSessionAlive: function() {
      Infini.Base.AjaxHelper.makeRequest('GET', '/Account/KeepSessionAlive/', null, {
        async: true,
        scope: this,
        waitMessage: '',
        successMessage: '',
        failureMessage: ''
      });
    },

    deleteUserUIProfile: function(controlIds) {
      var confirmMsg = Infini.Base.LocDef.ResetWindowToDefaultsConfirm;
      Ext.Msg.confirm(Infini.Base.LocDef.DefaultSettings, confirmMsg, function confirmCallback(response) {
        if (response === 'yes')
          if (InfiniApp.user.canPersistUICustomizations)
            Ext.state.Manager.getProvider().stop();
        try {
          Ext.each(controlIds, function(controlId) {
            Ext.state.Manager.clear(controlId);
          });
        } finally {
          if (InfiniApp.user.canPersistUICustomizations)
            Ext.state.Manager.getProvider().start();
        }
      }, this);
    },

    saveUserUIProfileAsDefaultForRole: function(settings) {
      var confirmMsg = String.format(Infini.Base.LocDef.SaveCurrentWindowSettingsAsDefaultForRoleConfirm, InfiniApp.user.ApplicationRole);
      Ext.Msg.confirm(Infini.Base.LocDef.DefaultSettingsForRole, confirmMsg, function confirmCallback(response) {
        if (response === 'yes') {

          Infini.Base.AjaxHelper.makeRequest('POST', '/Account/SaveUserUIProfileAsRoleDefault', undefined, {
            scope: this,
            params: { data: Ext.util.JSON.encode(settings) },
            waitMessage: String.format(Infini.Base.LocDef.SaveCurrentWindowSettingsAsDefaultForRoleWaitMessage, InfiniApp.user.ApplicationRole),
            successMessage: String.format(Infini.Base.LocDef.SaveCurrentWindowSettingsAsDefaultForRoleSuccessMessage, InfiniApp.user.ApplicationRole),
            failureMessage: String.format(Infini.Base.LocDef.SaveCurrentWindowSettingsAsDefaultForRoleFailureMessage, InfiniApp.user.ApplicationRole)
          }
          );
        }
      }, this);
    },

    getFavoriteReportNames: function() {
      if (!this.favoriteReportNames)
        this.favoriteReportNames = (Ext.state.Manager.get(this.favoriteReportsKey) || []).slice();

      return this.favoriteReportNames;
    },
    saveFavoriteReportNames: function(reportNames) {
      this.favoriteReportNames = reportNames;

      Ext.state.Manager.set(this.favoriteReportsKey, this.favoriteReportNames.slice());
    },
    refreshFavoriteReports: function() {
      this.getFavoriteReportNames();

      InfiniApp.reports.forEach(i => i.IsMarkedFavorite = this.favoriteReportNames.indexOf(i.Name) > -1);
    },
    getFavoriteReports: function() {
      let list = (InfiniApp.reports && InfiniApp.reports.filter(i => i.IsMarkedFavorite === true)) || [];
      let orderedList = []

      this.getFavoriteReportNames();
      this.favoriteReportNames.forEach((reportName) => {
        const reports = list.filter(i => i.Name === reportName);
        if (reports && reports.length > 0)
          orderedList.push(reports[0]);
      });

      return orderedList;
    },
    updateReportFavoriteProperty: function(reportName, markFavorite) {
      this.getFavoriteReportNames();

      // Update the favorite information in the cached reports
      InfiniApp.reports.filter(i => i.Name === reportName).forEach(i => i.IsMarkedFavorite = markFavorite);

      // Save favorite reports by updating the state
      const reportNdx = this.favoriteReportNames.indexOf(reportName);
      if (markFavorite) {
        if (reportNdx === -1)
          this.favoriteReportNames.push(reportName)
      } else {
        if (reportNdx > -1)
          this.favoriteReportNames.splice(reportNdx, 1);
      }
      Ext.state.Manager.set('FAVORITE_REPORTS', this.favoriteReportNames.slice())
    },
    isFavoriteReport: function(reportName) {
      this.getFavoriteReportNames();

      return this.favoriteReportNames.indexOf(reportName) > -1;
    },
    base64ToBlob: function(base64) {
      const binaryString = atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; ++i) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      return new Blob([bytes], { type: 'application/pdf' });
    }
  };
}();


Infini.Base.AjaxHelper = function() {

  var hideWaitBox = function(requestObj) {
    if (requestObj.options && requestObj.options.waitBox)
      requestObj.options.waitBox.hide();
  };

  var getProcessedErrorMessageInternal = function(responseObj) {
    var message = '';
    if (!responseObj) {
      message = Infini.Base.LocDef.AnErrorOccurredOnTheServerSide;
    } else if (responseObj.responseJSON) {
      message = (responseObj.options && responseObj.options.failureMessage) || '';
      if (responseObj.responseJSON.errorMsg || responseObj.responseJSON.errors) {
        message += (message ? '<br/><br/><ul class="errorList">' : '');
        if (responseObj.responseJSON.errorMsg) {
          const errorMsg = Infini.Base.Helper.decodeHTMLEntities(responseObj.responseJSON.errorMsg);
          message += '<li>' + errorMsg + '</li>';
        }
        if (responseObj.responseJSON.errors) {
          Ext.each(responseObj.responseJSON.errors, function(item) {
            var caption = item.caption || item.id;
            if (caption)
              message += '<li><span style="font-weight: bold">' + caption + '</span>: ' + item.msg + '</li>';
            else
              message += '<li>' + item.msg + '</li>';
          }, this);
        }
        message += '</ul>';
      }
    } else {
      message = (responseObj.options && responseObj.options.failureMessage) || '';

      var e = responseObj.fullStatus ? responseObj.fullStatus.error : undefined;
      if (e) {
        var fullStatusMessage;
        if (e.number)
          fullStatusMessage += '<b>' + Infini.Base.LocDef.NumberAbbr + ':</b> ' + e.number + '<br/><br/>';
        if (e.name)
          fullStatusMessage += '<b>' + Infini.Base.LocDef.Name + ':</b> ' + e.name + '<br/><br/>';
        if (e.message)
          fullStatusMessage += '<b>' + Infini.Base.LocDef.Message + ':</b> ' + e.message + '<br/><br/>';
        if (e.description)
          fullStatusMessage += '<b>' + Infini.Base.LocDef.Description + ':</b> ' + e.description;
        if (fullStatusMessage)
          message += (message ? '<br/><br/>' : '') + fullStatusMessage;
      }

      if (responseObj.responseText) {
        var responseTitle = Ext.ux.util.extractTagContent('title', responseObj.responseText);
        if (responseTitle && responseTitle.length > 1)
          message += (message ? '<br/><br/>' : '') + responseTitle[1];
      }
    }

    return message;
  };

  var handleFailureInternal = function(responseObj) {
    var message = getProcessedErrorMessageInternal(responseObj);

    if (message)
      Infini.Base.Helper.showMessageBox('error', message);
  };

  var jsonHook = function(requestObj, transportSuccess, responseObj) {
    var returnResult = false;

    if (transportSuccess) {
      // Now evaluate application logic errors
      returnResult = responseObj.responseJSON && (responseObj.responseJSON.success === true || requestObj.options.url === '/DirectRouter/Index');
      if (returnResult) {
        let message = '';

        if (requestObj.options.url === '/DirectRouter/Index') {
          if (Ext.isArray(responseObj.responseJSON)) {
            let directCallsWithError = responseObj.responseJSON.filter(i => i.success === false);
            if (directCallsWithError.length > 0) {
              message += Infini.Base.LocDef.FollowingErrorsOccurredDuringPopulatingDirectLookups + '<br/><br/><ul style="list-style-type: disc">';
              directCallsWithError.forEach(i => {
                message += '<li>' + Infini.Base.Helper.decodeHTMLEntities(i.errorMsg) + '</li>';
              });
              message += '</ul>';

              if (!Ext.isEmpty(message)) {
                Infini.Base.Helper.showMessageBox('error', message);
                return;
              }
            }
          } else if (responseObj.responseJSON.success === false) {
            message += Infini.Base.LocDef.FollowingErrorsOccurredDuringPopulatingDirectLookups + '<br/><br/><ul style="list-style-type: disc">';
            message += '<li>' + Infini.Base.Helper.decodeHTMLEntities(responseObj.responseJSON.errorMsg) + '</li>';
            message += '</ul>';
            if (!Ext.isEmpty(message)) {
              Infini.Base.Helper.showMessageBox('error', message, { appendMsg: true });
              return;
            }
          }
        } else {
          // If the request contains multiple inner actions it may complete partially and return succcess.
          // Therefore we have to show the errors of unsuccessfull actions
          if (responseObj.responseJSON.errors) {
            if (responseObj.responseJSON.resultMessage) {
              message += Infini.Base.Helper.decodeHTMLEntities(responseObj.responseJSON.resultMessage) + '<br/>';
            }

            message += (message ? '<br/><br/><ul style="list-style-type: disc">' : '');
            Ext.each(responseObj.responseJSON.errors, function(item) {
              var caption = item.caption || item.id;
              if (caption)
                message += '<li><span style="font-weight: bold">' + caption + '</span>: ' + item.msg + '</li>';
              else
                message += '<li>' + caption + '</li>';
            }, this);
            message += '</ul>';

            if (message)
              Infini.Base.Helper.showMessageBox('error', message);
          } else {
            // If response contains resultMessage show that instead of successMessage
            if (responseObj.responseJSON.resultMessage)
              Infini.Base.Helper.notifyCompleted(Infini.Base.Helper.decodeHTMLEntities(responseObj.responseJSON.resultMessage));
            else if (responseObj.options && responseObj.options.successMessage)
              Infini.Base.Helper.notifyCompleted(responseObj.options.successMessage);
          }
        }
      } else {
        if (typeof InfiniApp !== 'undefined') {
          // When cookie .ASPXAUTH is deleted, we will redirect
          var isResponseLoginPage = false;
          Ext.each(InfiniApp.catchLoginPageKeywords, function(keyword) {
            if (responseObj.responseText.indexOf(keyword) > 0) {
              isResponseLoginPage = true;
              return false;
            }
          }, this);

          if (isResponseLoginPage === true) {
            if (InfiniApp && (!InfiniApp.user || InfiniApp.user.Impersonating || InfiniApp.timeOutLoginPromptEnabled === false)) {
              Infini.Base.Helper.logout();
              return;
            } else {
              Infini.Base.Helper.showNotification('Uzun bir süre işlem yapmadığınız için oturum süreniz dolmuştur. Lütfen tekrar giriş yapınız.',
                'warning', 'Oturum süresi doldu');
              Infini.Base.Helper.showLoginDialog(true);
              return;
            }
          }
        }

        if (responseObj.options.useCommonFailureHandler !== 'false')
          handleFailureInternal(responseObj);
      }
    } else if (responseObj.options.useCommonFailureHandler !== 'false') {
      // Other problem
      handleFailureInternal(responseObj);
    }

    //return returnResult; // 'false' prevents any further callbacks from executing
  };

  var addLogItem = function(logItem) {
    if (!logItem || !Ext.isDefined(logItem.url))
      return;

    if (typeof InfiniLog === 'undefined')
      InfiniLog = {};
    if (!InfiniLog.xhrList)
      InfiniLog.xhrList = new Ext.util.MixedCollection(false, function(o) { return o.url; });
    if (InfiniLog.xhrList.getCount() === 5)
      InfiniLog.xhrList.removeAt(0);
    InfiniLog.xhrList.add(logItem.url, logItem);
  };

  var updateLogItem = function(url, state) {
    if (typeof InfiniLog !== 'undefined' && InfiniLog.xhrList && InfiniLog.xhrList.containsKey(url)) {
      var logItem = InfiniLog.xhrList.get(url);
      if (logItem)
        logItem.state = state;
    }
  };


  Ext.lib.Ajax.on({
    request: function(method, uri, cb, data, options) {
      //console.log('Ext.lib.Ajax.on request');
      var allowedAnonymousRoutes = [Infini.Base.Helper.loginUrl, '/Account/GetUser', '/Account/ExternalLogin',
        '/Account/SignInWithMicrosoft', '/Account/ForgotPassword', '/Account/FinalizeResetPasswordWithCode'];

      if (typeof InfiniApp === 'undefined' || !InfiniApp.user) {
        var result = false
        for (var i = 0; i < allowedAnonymousRoutes.length; i++) {
          result = uri.indexOf(allowedAnonymousRoutes[i]) > -1;
          if (result)
            break;
        }
        if (result !== true)
          return false;
      }

      var currentDateTime = new Date();
      var logItem = {
        requestDateTime: currentDateTime.format ? currentDateTime.format('d/m/Y H:i:s') : currentDateTime,
        url: options ? options.url : uri,
        method: method,
        params: options ? options.params : {}
      };
      if (typeof InfiniApp !== 'undefined' && InfiniApp.getDesktop) {
        var desktop = InfiniApp.getDesktop();
        if (desktop) {
          var activeWindow = desktop.getActiveWindow();
          var activeWindowId = activeWindow ? activeWindow.id : '';

          logItem.activeWindowId = activeWindowId;
        }
      }

      addLogItem(logItem);

      // Without creating a proxy with async parameter, we can not load interfere with stores async/load modes.
      // But whenever we specify options in load method of a store it goes to the options.request.arg.
      // So if we find this structure in an options we check if it has async parameter that is false
      // If so we change it in options.async.
      if (options.request && options.request.arg && options.request.arg.async === false)
        options.async = false;
    },

    beforesend: function(conn, method, uri, cb, data, options) {
      //console.log('Ext.lib.Ajax.on beforesend');
      if (options.waitMessage)
        options.waitBox = Ext.MessageBox.wait(options.waitMessage, Ext.form.BasicForm.prototype.waitTitle);
    },

    response: function(requestObj, responseObj, callback, isAbort) {
      //console.log('Connection.on requestresponse2');
      if (requestObj && requestObj.options)
        updateLogItem(requestObj.options.url, 'tsuccess');
      //HTTP transport succeeded
      hideWaitBox(requestObj);
      if (responseObj.options.useJsonHook !== false)
        return jsonHook(requestObj, true, responseObj);
    },

    // handle transport failure or when the JSON was invalid
    exception: function(requestObj, responseObj, callback, isAbort) {
      //console.log('Connection.on requestexception2');
      if (requestObj && requestObj.options)
        updateLogItem(requestObj.options.url, 'exception');
      //HTTP transport(or other failure) failed
      hideWaitBox(requestObj);
      if (responseObj && responseObj.options && responseObj.options.useJsonHook !== 'false')
        return jsonHook(requestObj, false, responseObj);
    },

    abort: function(requestObj, cb) {
      //console.log('Connection.on requestabort2');
      if (requestObj && requestObj.options)
        updateLogItem(requestObj.options.url, 'abort');
      hideWaitBox(requestObj);
    },

    timeout: function(requestObj, cb) {
      //console.log('Connection.on requesttimeout2');
      if (requestObj && requestObj.options)
        updateLogItem(requestObj.options.url, 'timeout');
      hideWaitBox(requestObj);
      Infini.Base.Helper.consoleOut('log', ['A.on.timeout', requestObj]);
    }
  });

  var errorStatusHandler = function(status, requestObj, responseObj, callback, isAbort) {
    hideWaitBox(requestObj);
    Infini.Base.Helper.consoleOut('info', 'A.onStatus: ' + status + ', uri: ' + requestObj.options.url);
    if (status === '401') // Unauthorized
      document.location = Infini.Base.Helper.loginUrl;
  };

  Ext.lib.Ajax.unStatus([302, 401, 403, 404, 500], errorStatusHandler); // 403 Forbidden, 404 Not Found, 500 Internal Server Error
  Ext.lib.Ajax.onStatus([302, 401, 403, 404, 500], errorStatusHandler);

  return {

    makeRequest: function(method, uri, cb, options) {
      // Override default options with sent options to set undefined defaults
      options = Ext.apply({
        async: true,
        scope: null,
        params: null,
        // Custom properties
        waitMessage: 'İşlem yapılıyor...',
        failureMessage: Infini.Base.LocDef.OperationCouldNotBeCompleted,
        successMessage: 'İşlem başarıyla tamamlandı.'
      }, options || {});

      options = Ext.apply(options, {
        method: method,
        url: uri,
        callback: cb
      });

      Ext.Ajax.request(options);
    },

    handleFailure: function(responseObj) {
      handleFailureInternal(responseObj);
    },

    getProcessedErrorMessage: function(responseObj) {
      return getProcessedErrorMessageInternal(responseObj);
    }

  };

}();
Infini.BaseWindow = Ext.extend(Ext.Window, {
  stateful: true,
  maximized: true,
  border: false,
  shim: false,
  animCollapse: false,
  constrainHeader: true,
  layout: 'fit',
  onEsc: Ext.emptyFn,
  initComponent: function() {

    this.stateEvents = this.stateEvents || [];
    this.stateEvents.push('maximize', 'restore');

    Infini.BaseWindow.superclass.initComponent.apply(this, arguments);

    this.keys = this.keys || [];
    this.keys.push({
      key: Ext.EventObject.F4,
      ctrl: true,
      scope: this,
      stopEvent: true,
      fn: function() {
        if (this.closeAction)
          this[this.closeAction].createDelegate(this, []);
        else
          this.close();
      }
    });

    if (typeof InfiniApp !== 'undefined' && this.stateful !== false) {
      this.tools = this.tools || [];
      this.tools.unshift({
        id: 'resetLayout',
        qtip: Infini.Base.LocDef.ResetWindowToDefaults,
        handler: function(event, toolEl, panel) {
          var controls = this.findBy(function(component, container) {
            return component.stateful && (component instanceof Infini.BaseGridPanel || component instanceof Infini.EditFormPanel ||
              component instanceof Infini.CriteriaPanel);
          });

          var controlIds = [this.stateId || this.id];
          Ext.each(controls, function(item) {
            controlIds.push(this.stateId || this.id);
          });
          Infini.Base.Helper.deleteUserUIProfile(controlIds);
        },
        scope: this
      });

      if (InfiniApp.user.canPersistUICustomizationsAsDefault) {
        this.tools.unshift({
          id: 'linkLayout',
          qtip: Infini.Base.LocDef.SaveCurrentWindowSettingsAsDefaultForRole,
          handler: function(event, toolEl, panel) {
            var controls = this.findBy(function(component, container) {
              return component.stateful && (component instanceof Infini.BaseGridPanel || component instanceof Infini.EditFormPanel ||
                component instanceof Infini.CriteriaPanel);
            });
            controls.unshift(this);

           var stateProvider = Ext.state.Manager.getProvider();
           var settingsToSave = [];
            Ext.each(controls, function(control) {
              var controlId = control.stateId || control.id;
              var stateValue = Ext.state.Manager.get(controlId);
              if (stateValue) {
                settingsToSave.push({
                  Name: controlId, 
                  Value: stateProvider.encodeValue(stateValue)
                });
              }
            });

            Infini.Base.Helper.saveUserUIProfileAsDefaultForRole(settingsToSave);
          },
          scope: this
        });
      }

      if (!this.criteriaPanelRef) {
        if (this.items) {
          this.items.each(function(item, index, length) {
            if (item instanceof Infini.CriteriaPanel)
              this.criteriaPanelRef = item;
            return !this.criteriaPanelRef;
          }, this);

          if (this.criteriaPanelRef && this.criteriaPanelRef.criteriaRegion && !this.criteriaPanelRef.criteriaHidden) {
            this.tools.unshift({
              id: 'toggleCriteria',
              qtip: Infini.Base.LocDef.ToggleCriteria,
              handler: function (event, toolEl, panel) {
                this.toggleCriteria();
              },
              scope: this
            });
          }
        }
      }
    }

    //TODO: Find out why this doesn't work in initEvents
    this.on({
      'beforedestroy': this.onBeforeDestroy,
      'beforerender': this.onBeforeRender,
      'afterrender': this.onAfterRender,
      'show': this.onAfterShow,
      'activate': this.onActivate,
      'deactivate': this.onDeactivate,
      scope: this
    });
  },
  initEvents: function() {  // jshint ignore:line
    Infini.BaseWindow.superclass.initEvents.call(this);

    if (typeof Infini.BaseGridPanel === 'undefined')
      return;

    // If a grid is not assigned yet, find if window contains a Infini.BaseGridPanel
    // If there is a Infini.BaseGridPanel then map a key to it's loadStore method
    if (!this.grid) {
      var grid;
      if (this.items) {
        this.items.each(function(item, index, length) {
          if (item instanceof Infini.BaseGridPanel)
            grid = item;
          return !grid;
        }, this);

        if (grid) {
          this.grid = grid;
          var map = new Ext.KeyMap(this.el, {
            key: Ext.EventObject.Q,
            ctrl: true,
            stopEvent: true,
            fn: function() {
              if (grid.loadMode === 'remote')
                grid.loadStore.call(grid);
            }
          });
        }
      }
    }
  },
  onBeforeDestroy: function(comp) {
  },
  onBeforeRender: function(comp) {
  },
  onAfterRender: function(comp) {
    this.setMainTopToolbar(this);

    if (this.topToolbar) {
      var helpContent = Infini.Base.Helper.getHelpContent(this.idBase || this.id);
      if (helpContent) {
        var menu = [];

        // Long Help
        if (helpContent.longHelpUrl) {
          menu.push(new Ext.Action({
            text: Infini.Base.LocDef.ExtensiveHelp,
            iconCls: 'helpLong',
            handler: function() {
              window.open(Infini.Base.Helper.baseHelpUrl + helpContent.longHelpUrl, 'infini_help_wnd');
            }
          }));
        }

        // Short Helps
        if (helpContent.shortHelpUrls && helpContent.shortHelpUrls.length > 0) {
          if (menu.length > 0)
            menu.push('-');

          Ext.each(helpContent.shortHelpUrls, function(item) {
            if (item.name && item.url) {
              menu.push(new Ext.Action({
                text: item.name,
                iconCls: 'helpShort',
                handler: function() {
                  Infini.Base.Helper.showPopup(Infini.Base.Helper.baseHelpUrl + item.url, true, 'infini_help_short_wnd');
                }
              }));
            }
          });
        }
        
        // Videos
        if (helpContent.videos && helpContent.videos.length > 0) {
          if (menu.length > 0)
            menu.push('-');

          Ext.each(helpContent.videos, function(item) {
            if (item.name && item.url) {
              menu.push(new Ext.Action({
                text: item.name,
                iconCls: 'video',
                handler: function() {
                  Infini.Base.Helper.showPopup(Infini.Base.Helper.baseHelpVideoUrl + item.url, true, 'infini_help_video_wnd');
                }
              }));
            }
          });
        }

        if (menu.length > 0) {
          var toolbarHasFill = false;

          this.topToolbar.items.each(function(item) {
            if (item.isFill) {
              toolbarHasFill = true;
              return false;
            }
          });

          if (!toolbarHasFill)
            this.topToolbar.insert(this.topToolbar.items.length, '->');
          this.topToolbar.insert(this.topToolbar.items.length, {
            tooltip: Infini.Base.LocDef.Help,
            iconCls: 'help',
            menu: menu
          });
        }
      }
    }
  },
  onAfterShow: function(comp) {
    //console.log('aftershow', comp.id);
    if (this.resizeToContent) {
      var totalHeight = 0;
      Ext.each(this.items.items, function(item) {
        if (!item.hidden)
          totalHeight += item.getSize().height + item.margins.top + item.margins.bottom;
      });
      this.setHeight(totalHeight + 30);

      if (!this.stateful)
        this.setPosition(this.x, this.y - totalHeight);
    }
  },
  onActivate: function(comp) {
    //console.log('onActivate', comp.id);
  },
  onDeactivate: function(comp) {
    //console.log('onDeactivate', comp.id);
  },
  adjustForGrid: function(grid) { // jshint ignore:line
    this.grid = grid;
    var map = new Ext.KeyMap(this.el, {
      key: Ext.EventObject.Q,
      ctrl: true,
      stopEvent: true,
      fn: function() {
        grid.loadStore.call(grid);
      }
    });
  },
  getState: function() {
    return Ext.apply(Infini.BaseWindow.superclass.getState.call(this) || {}, {
      maximized: this.maximized
    });
  },
  setMainTopToolbar: function(parent) {
    if (parent.getTopToolbar) {
      this.topToolbar = parent.getTopToolbar();
      if (this.topToolbar)
        return;
    }

    if (parent.items) {
      var usedItems;
      
      if (parent.items instanceof Array)
        usedItems = parent.items;
      else if (parent.items.items && parent.items.items instanceof Array)
        usedItems = parent.items.items;

      if (usedItems) {
        Ext.each(usedItems, function(item) {
          this.setMainTopToolbar(item);
          if (this.topToolbar)
            return false;
        }, this);
      }
    }
  },
  getWindowTitle: function() {
    return { title: this.title, tooltipTitle: this.title };
  },
  updateWindowTitle: function() {
    var winTitle = this.getWindowTitle();
//    if (this.internalId)
//      winTitle.title = String.format('[{0}] - {1}', this.internalId, winTitle.title);
    
    if (typeof InfiniApp !== 'undefined')
      InfiniApp.getDesktop().updateWindowTitle(this, winTitle.title, winTitle.tooltipTitle, winTitle.tooltipText);
  },
  toggleCriteria: function() {
    this.criteriaPanelRef.criteriaRegion.toggleCollapse(false);
  }
});

Ext.reg('basewindow', Infini.BaseWindow);

Infini.DialogWindow = Ext.extend(Infini.BaseWindow, {
  maximized: false,
  resizable: true,
  closeAction: 'close',
  layout: 'fit',
  hideCancelButton: false,
  disableEnterKeySubmission: false,

  initComponent: function() {
    var readOnlyConfig = {
      modal: true,
      border: false,
      minimizable: false,
      maximizable: false
    };

    this.customButtons = this.customButtons || [];

    if (this.showButtons !== false) {
      var keys = []

      if (this.hideCancelButton !== true) {
        keys.push({
          key: 27, // Esc key
          fn: function() {
            this.onCancel();
          },
          scope: this
        });
      }

      if (!this.disableEnterKeySubmission) {
        keys.push({
          key: [13], // enter key
          scope: this,
          fn: function() {
            this.onOK();
          }
        });
      }

      var buttons = this.customButtons.concat([{
        handler: function() {
          this.onOK();
        },
        scope: this,
        text: this.okButtonText || Infini.Base.LocDef.OK
      }])

      if (this.hideCancelButton !== true) {
        buttons.push({
          handler: function() {
            this.onCancel();
          },
          scope: this,
          text: Infini.Base.LocDef.Cancel
        })
      }

      Ext.apply(readOnlyConfig, {
        keys: keys,
        buttons: buttons
      });
    }

    Ext.apply(this, readOnlyConfig);
    Ext.apply(this.initialConfig, readOnlyConfig);

    Infini.DialogWindow.superclass.initComponent.apply(this, arguments);
  },
  constructor: function(config) {

    Infini.DialogWindow.superclass.constructor.apply(this, [config]);

    this.updateWindowTitle();
  },
  onOK: function() {
    this.checkIfUncommittedChangesExist(true, function(doCallCallback) {
      if (doCallCallback && this.callback)
        this.callback.call(this.scope || this);
      this[this.closeAction]();
    }, this);
  },
  onCancel: function() {
    this[this.closeAction]();
  },
  // override the superclass show() so the callback is not called from show()
  show: function(cb, scope, animateTarget) {
    if (!this.rendered)
      this.render(Ext.getBody());
    if (this.hidden === false) {
      this.toFront();
      return;
    }
    if (this.fireEvent("beforeshow", this) === false)
      return;
    if (cb)
      this.callback = cb;
    if (scope)
      this.scope = scope;
    this.hidden = false;
    this.beforeShow();
    this.afterShow();
  },
  checkIfUncommittedChangesExist: function(isOK, callback, scope) {
    if (callback && scope)
      callback.call(scope, true);
  },
  showUncommittedChangesExistWarning: function(isOK, callback, scope) {
    if (isOK) {
      Infini.Base.Helper.showMessageBox('warning', String.format('{0} {1}', Infini.Base.LocDef.ThereAreUnsavedChanges, Infini.Base.LocDef.ConfirmSaveTheseChanges), {
        title: Infini.Base.LocDef.SaveChanges,
        callback: function(btn, text) {
          if (btn === 'yes') {
            if (callback && scope)
              callback.call(scope, true);
          } else if (btn === 'no') {
            if (callback && scope)
              callback.call(scope, false);
          }
        },
        scope: this
      });
    }
  }
});

Ext.ns('Infini.Authentication');

Infini.Authentication.LoginDialog = Ext.extend(Infini.DialogWindow, {
  width: 480,
  layout: 'fit',
  plain: true,
  closable: false,
  draggable: false,
  resizable: false,
  showButtons: false,

  getConfigurableParamsDefaults: function() {
    return {
      azureADEnabled: true
    };
  },

  initComponent: function() {
    this.initialize('loginDialog');

    var isBrowserVersionSupported = Infini.Base.Helper.isBrowserVersionSupported();
    var windowHeight = isBrowserVersionSupported ? 380 : 480;

    this.stateProvider = new Ext.state.CookieProvider({
      expires: new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 30)) //30 days
    });

    var readOnlyConfig = {
      internalId: 'A0001',
      id: 'winLoginDialog',
      title: String.format('[{0}] {1}', 'A0001', Infini.Base.LocDef.LoginCaption),
      height: windowHeight,
      items: {
        ref: 'formPanel',
        xtype: 'loginform',
        isForTimeout: this.isForTimeout,
        isBrowserVersionSupported: isBrowserVersionSupported
      },
      keys: [{
        key: [13], // enter key
        scope: this,
        fn: function() {
          this.onOK();
        }
      }],
      buttonAlign: 'left',
      buttons: [{
        iconCls: 'login login-with-ms-' + this.stateProvider.get('language', 'tr-TR'),
        handler: function() {
          window.location = '/Account/ExternalLogin?provider=OpenIdConnect&language=' + this.stateProvider.get('language', 'tr-TR');
        },
        scope: this
      }, '->', {
        iconCls: 'login login-with-company-' + this.stateProvider.get('language', 'tr-TR'),
        handler: function() {
          this.onOK();
        },
        scope: this
      }]
    };

    Ext.apply(this, readOnlyConfig);
    Ext.apply(this.initialConfig, readOnlyConfig);

    Infini.Authentication.LoginDialog.superclass.initComponent.apply(this, arguments);
  },
  onOK: function() {
    this.formPanel.submitOp();
  },
  successCallback: function() {
    if (this.callback)
      this.callback.call(this.scope || this);

    this[this.closeAction]();
  }
});

Infini.Authentication.LoginFormPanel = Ext.extend(Ext.form.FormPanel, {

  initComponent: function() {
    this.initialize('loginFormPanel');

    this.stateProvider = Infini.Base.Helper.getCookieStateProvider();

    var readOnlyConfig = {
      id: 'formLogin',
      baseCls: 'x-plain',
      frame: false,
      autoHeight: true,
      isForTimeout: this.isForTimeout === true ? true : false,
      labelWidth: 100,
      defaults: {
        anchor: '0'
      },
      defaultType: 'textfield',
      items: [{
        ref: 'usernameField',
        fieldLabel: Infini.Base.LocDef.UserName,
        name: 'username',
        anchor: '-15',
        readOnly: this.isForTimeout === true
      }, {
        xtype: 'compositefield',
        fieldLabel: Infini.Base.LocDef.Password,
        items: [{
          ref: '../passwordField',
          xtype: 'textfield',
          inputType: 'password',
          name: 'password',
          width: 245
        }, {
          xtype: 'button',
          text: Infini.Base.LocDef.ForgotPassword,
          handler: function() {
            this.showForgotPasswordDialog();
          },
          scope: this
        }]
      }, {
        ref: 'languageField',
        xtype: 'combo',
        fieldLabel: Infini.Base.LocDef.Language,
        store: new Ext.data.ArrayStore({
          fields: ['Id', 'Name'],
          data: [
            ['tr-TR', 'Türkçe'],
            ['en-US', 'English']
          ]
        }),
        hiddenName: 'language',
        anchor: '-15',
        valueField: 'Id',
        displayField: 'Name',
        mode: 'local',
        triggerAction: 'all',
        forceSelection: true,
        editable: false,
        readOnly: this.isForTimeout === true,
        listeners: {
          scope: this,
          'select': this.onLanguageChange
        }
      }, {
        xtype: 'fieldset',
        cls: 'warning-fieldset',
        title: Infini.Base.LocDef.UnsupportedBrowserVersion_Title,
        hidden: this.isBrowserVersionSupported,
        anchor: '-15',
        bodyStyle: 'padding: 2px 4px;',
        items: [{
          xtype: 'displayfield',
          hideLabel: true,
          value: Infini.Base.LocDef.UnsupportedBrowserVersion,
          style: 'font-size: 12px;'
        }]
      }],
      listeners: {
        scope: this,
        'actioncomplete': this.onActionSuccess,
        'actionfailed': this.onActionFailed
      },
      url: Infini.Base.Helper.loginUrl
    };

    Ext.apply(this, readOnlyConfig);
    Ext.apply(this.initialConfig, readOnlyConfig);

    Infini.Authentication.LoginFormPanel.superclass.initComponent.apply(this, arguments);

    this.on('render', function() {
      var f = this.passwordField;
      if (f)
        f.focus();
    }, this, { delay: 200 });

    if (this.stateProvider.get('language') === 'en')
      this.stateProvider.set('language', 'en-US');
    else if (this.stateProvider.get('language') === 'tr')
      this.stateProvider.set('language', 'tr-TR');

    this.usernameField.setValue(this.stateProvider.get('username'));
    this.languageField.setValue(this.stateProvider.get('language', 'tr-TR'));
  },
  showForgotPasswordDialog: function() {
    Ext.MessageBox.prompt(Infini.Base.LocDef.ForgotPassword,
      Infini.Base.LocDef.PleaseEnterYourEmailAddress, function(btn, text) {
        if (btn === 'ok') {
          var email = Infini.Base.Helper.trimSpace(text);
          if (Ext.isEmpty(email))
            this.showForgotPasswordDialog();
          else {
            Infini.Base.AjaxHelper.makeRequest('POST', '/Account/ForgotPassword',
              function(options, opSuccess, response) {
              }, {
              scope: this,
              params: {
                email: email
              },
              waitMessage: Infini.Base.LocDef.YourRequestIsBeingReceived,
              failureMessage: Infini.Base.LocDef.AnErrorOccuredWhileYourRequestIsBeingReceived,
              successMessage: Infini.Base.LocDef.PwdResetRequestHasBeenReceived
            });
          }
        }
      }, this)
  },
  setStateOnLocalStorage: function(key, value) {
    if (localStorage) {
      var keyx;
      if (key === 'language')
        keyx = 'app-state-lang';
      else if (key === 'username')
        keyx = 'app-state-username';
      if (keyx)
        localStorage.setItem(keyx, Ext.encode(value));
    }
  },
  onLanguageChange: function(comp, rec, index) {
    if (comp.startValue === comp.getValue())
      return;
    this.stateProvider.set('language', comp.getValue());
    this.setStateOnLocalStorage('language', comp.getValue());
    this.lastLanguage = comp.getValue();
    this.getForm().submit({
      params: { changeLanguage: true }
    });
  },
  submitOp: function() {
    this.lastUserName = this.usernameField.getValue();
    this.lastLanguage = this.languageField.getValue();

    this.getForm().submit({
      reset: true,
      waitTitle: Infini.Base.LocDef.WaitTitle,
      waitMsg: Infini.Base.LocDef.SessionIsStarting,
      failureMessage: Infini.Base.LocDef.SessionCanNotBeStarted
    });
  },
  onActionSuccess: function(form, action) {
    if (action && action.success) {
      this.stateProvider.set('language', this.lastLanguage);
      this.setStateOnLocalStorage('language', this.lastLanguage);
      if (action.options.params && action.options.params.changeLanguage === true)
        window.location = Infini.Base.Helper.loginUrl;
      else {
        this.stateProvider.set('username', this.lastUserName);
        this.setStateOnLocalStorage('username', this.lastUserName);
        if (this.ownerCt.successCallback)
          this.ownerCt.successCallback.call(this.ownerCt);

        var response = action.response;
        if (response && response.responseJSON && response.responseJSON.data && response.responseJSON.data.askForVerificationCode === true) {
          var securtityCodeEntryWindow = new Infini.Authentication.VerificationCodeEntry({
            expireDate: (new Date()).add(Date.SECOND, response.responseJSON.data.duration),
            isForTimeout: form.isForTimeout
          });
          securtityCodeEntryWindow.show();
        } else {
          // redirect the window if not forTimeOut
          if (this.isForTimeout !== true)
            window.location = Infini.Base.Helper.getHomeUrl();
        }
      }
    }
  },
  onActionFailed: function(form, action) {
    Infini.Base.AjaxHelper.handleFailure(action.response);
  }
});

Ext.reg('loginform', Infini.Authentication.LoginFormPanel);


Infini.Authentication.VerificationCodeEntry = Ext.extend(Infini.DialogWindow, {

  initComponent: function() {

    var readOnlyConfig = {
      internalId: 'A0002',
      id: 'winVerificationCodeEntry',
      title: Infini.Base.LocDef.VerificationCodeEntry,
      iconCls: 'verificationCode',
      height: 350,
      width: 480,
      draggable: false,
      resizable: false,
      formPanel: new Infini.Authentication.VerificationCodeEntryFormPanel({
        expireDate: this.expireDate,
        isForTimeout: this.isForTimeout
      })
    };

    readOnlyConfig.items = readOnlyConfig.formPanel;

    Ext.apply(this, readOnlyConfig);
    Ext.apply(this.initialConfig, readOnlyConfig);

    Infini.Authentication.VerificationCodeEntry.superclass.initComponent.apply(this, arguments);
  },
  onOK: function() {
    this.formPanel.submitOp();
  },
  onCancel: function() {
    this.formPanel.clearTimer();
    if (this.formPanel.isForTimeout !== true)
      window.location = Infini.Base.Helper.logoutUrl;
    else {
      this.close();
      Infini.Base.Helper.showLoginDialog(true);
    }
  },
  onBeforeDestroy: function(comp) {
    Infini.Authentication.VerificationCodeEntry.superclass.onBeforeDestroy.apply(this, arguments);

    this.formPanel.clearTimer();
  }
});

Infini.Authentication.VerificationCodeEntryFormPanel = Ext.extend(Ext.FormPanel, {

  initComponent: function() {
    Ext.apply(this, {
      id: 'formVerificationCode',
      baseCls: 'x-plain',
      labelWidth: 80,
      frame: false,
      height: 70,
      items: [{
        xtype: 'label',
        text: Infini.Base.LocDef.PleaseEnterVerificationCode,
        style: 'font-weight: bold; font-size: 14px;'
      }, {
        xtype: 'textfield',
        name: 'VerificationCode',
        inputType: 'password',
        fieldLabel: Infini.Base.LocDef.VerificationCode,
        labelStyle: 'margin-top: 10px;',
        style: 'margin-top: 10px;'
      }, {
        ref: 'expirationLabel',
        xtype: 'label',
        fieldLabel: Infini.Base.LocDef.RemainingTime,
        style: 'display: block; margin-top: 6px; font-size: 13px; font-weight: bold;'
      }],
      listeners: {
        scope: this,
        'actioncomplete': this.onActionComplete,
        'actionfailed': this.onActionFailed
      }
    });
    Infini.Authentication.VerificationCodeEntryFormPanel.superclass.initComponent.apply(this, arguments);

    this.on('render', function() {
      this.expirationTimer = Ext.TaskMgr.start({
        run: function(i) {
          var dateDiff = new Date(this.expireDate - new Date());
          if (dateDiff <= 0)
            this.clearTimer();
          else
            this.expirationLabel.setText(dateDiff.format('i:s'));
        },
        interval: 1000,
        scope: this
      });

      var f = this.getForm().findField('VerificationCode');
      if (f)
        f.focus();
    }, this, { delay: 200 });
  },
  clearTimer: function() {
    if (this.expirationTimer) {
      Ext.TaskMgr.stop(this.expirationTimer);
      this.expirationTimer = null;
    }
  },
  submitOp: function() {
    if (Ext.isEmpty(this.getForm().findField('VerificationCode').getValue()))
      return;

    this.getForm().submit({
      url: Infini.Base.Helper.loginUrl,
      waitMsg: Infini.Base.LocDef.VerificationCodeIsBeingAuthorized,
      failureMessage: Infini.Base.LocDef.AnErrorOccuredWhileVerificationCodeIsBeingAuthorized
    });
  },
  onActionComplete: function(form, action) {
    if (action && action.success) {
      this.clearTimer();
      if (form.isForTimeout !== true)
        window.location = Infini.Base.Helper.getHomeUrl();
      else
        this.ownerCt.close();
    }
  },
  onActionFailed: function(form, action) {
    var response = action.response;
    if (response && response.responseJSON) {
      if (response.responseJSON.data && response.responseJSON.data.ReturnBackToLoginPage === true) {
        this.clearTimer();
        Ext.MessageBox.show({
          msg: response.responseJSON.errorMsg, icon: Ext.MessageBox.ERROR, buttons: Ext.Msg.OK,
          fn: function() {
            if (form.isForTimeout !== true)
              window.location = Infini.Base.Helper.loginUrl;
            else {
              this.ownerCt.close();
              Infini.Base.Helper.showLoginDialog(true);
            }
          },
          scope: this
        });
      } else {
        this.getForm().reset();
        if (response.responseJSON.data && response.responseJSON.data.expireDate)
          this.expireDate = Date.parseDate(response.responseJSON.data.expireDate, Infini.Base.Helper.getFullDateFormat());
        Infini.Base.AjaxHelper.handleFailure(action.response);
      }
    }
  }
});

Ext.reg('verificationcodeentryformpanel', Infini.Authentication.VerificationCodeEntryFormPanel);

Ext.ns('Infini.Authentication');

Infini.Authentication.ResetPasswordWithCodeDialog = Ext.extend(Infini.DialogWindow, {
  width: 300,
  layout: 'fit',
  plain: true,
  closable: false,
  draggable: false,
  resizable: false,
  showButtons: true,
  hideCancelButton: true,
  iconCls: 'resetPassword',

  initComponent: function() {
    this.initialize('ResetPasswordWithCodeDialog');

    var readOnlyConfig = {
      internalId: 'A0079',
      id: 'winResetPasswordWithCodeDialog',
      title: String.format('[{0}] {1}', 'A0079', Infini.Base.LocDef.ResetPasswordWithCode),
      height: 360,
      items: {
        ref: 'formPanel',
        xtype: 'resetpwdform',
        resetPwdCode: this.resetPwdCode,
      }
    };

    Ext.apply(this, readOnlyConfig);
    Ext.apply(this.initialConfig, readOnlyConfig);

    Infini.Authentication.ResetPasswordWithCodeDialog.superclass.initComponent.apply(this, arguments);
  },
  onOK: function() {
    this.formPanel.submitOp();
  },
  successCallback: function() {
    if (this.callback)
      this.callback.call(this.scope || this);

    this[this.closeAction]();
  }
});

Infini.Authentication.ResetPasswordFormPanel = Ext.extend(Ext.form.FormPanel, {

  initComponent: function() {
    this.initialize('resetPasswordFormPanel');

    var readOnlyConfig = {
      id: 'formResetPwd',
      baseCls: 'x-plain',
      frame: false,
      autoHeight: true,
      labelWidth: 100,
      defaultType: 'textfield',
      items: [{
        ref: 'usernameField',
        fieldLabel: Infini.Base.LocDef.UserName,
        name: 'username',
        allowBlank: false,
        anchor: '-20'
      }, {
        id: 'newPassword',
        ref: 'newPasswordField',
        inputType: 'password',
        fieldLabel: Infini.Base.LocDef.NewPassword,
        name: 'newPassword',
        allowBlank: false,
        anchor: '-20'
      }, {
        ref: 'confirmPasswordField',
        inputType: 'password',
        fieldLabel: Infini.Base.LocDef.NewPasswordAgain,
        name: 'confirmPassword',
        allowBlank: false,
        vtype: 'password',
        initialPassField: 'newPassword',
        anchor: '-20'
      }]
    };

    Ext.apply(this, readOnlyConfig);
    Ext.apply(this.initialConfig, readOnlyConfig);

    Infini.Authentication.ResetPasswordFormPanel.superclass.initComponent.apply(this, arguments);

    this.on('render', function() {
      var f = this.usernameField;
      if (f)
        f.focus();
    }, this, { delay: 200 });

  },
  submitOp: function() {
    this.getForm().submit({
      method: 'POST',
      url: '/Account/FinalizeResetPasswordWithCode',
      waitTitle: Infini.Base.LocDef.WaitTitle,
      waitMsg: Infini.Base.LocDef.PasswordIsBeingReset,
      useCommonFailureHandler: 'false',
      scope: this,
      params: {
        code: this.resetPwdCode
      },
      failure: function(form, action) {
        if (action.response) {
          var obj = Ext.ux.util.getResponseJsonFromResponseText(action.response);
          if (obj && obj.errorMsg)
            Infini.Base.Helper.showMessageBox('error', String.format('{0}<br/><br/>{1}', Infini.Base.LocDef.AnErrorOccuredWhileResettingPassword, obj.errorMsg));
          else 
            Infini.Base.Helper.showMessageBox('error', Infini.Base.LocDef.AnErrorOccuredWhileResettingPassword);
        }
      },
      success: function(form, action) {
        Infini.Base.Helper.showMessageBox('info', Infini.Base.LocDef.PasswordIsSuccessfullyReset, {
          callback: function(btn, text) {
            window.location = Infini.Base.Helper.loginUrl;
          }
        })
      }
    });
  },
  onActionSuccess: function(form, action) {
    if (action && action.success) {
      window.location = Infini.Base.Helper.loginUrl;
    }
  }
});

Ext.reg('resetpwdform', Infini.Authentication.ResetPasswordFormPanel);
